// ./fe-build.sh homebase

import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import P from './components/common/dfile1.vue';
import V from './components/common/dfilev.vue';
import Common from './components/ynadmin/common/common.js';
import CommonTools from "./components/common.js";
import swal from 'sweetalert';
import survey from "./components/common/survey.vue";
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import 'vue2-datepicker/index.css';
import KProgress from 'k-progress';
import Share from './components/common/share.js';
import DropImg from "./components/common/dragImgFile.vue";
import DropImgAlt from "./components/common/dragImgAlt.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import DropImgOne from "./components/common/dragImgFileOne.vue";
import DropVdThumOne from "./components/common/dragVdThumFileOne.vue";
import DropVideoChoiceThum from "./components/common/dragVideoChoiceThumFile.vue";
import mobile from "is-mobile";

Vue.use(VueFileAgent);

Vue.component("pager", Pager);
Vue.component("dfile", P);
Vue.component("dfilev", V);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component("editor", Editor);
Vue.component('dropimg2', DropImg);
Vue.component('dropimg', DropImgAlt);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('dropimgone', DropImgOne);
Vue.component('dropvdthumone', DropVdThumOne);
Vue.component('dropvideochoicethum', DropVideoChoiceThum);
Vue.component('survey', survey);
Vue.component('k-progress', KProgress);

Vue.prototype.$pager = Pager;

const GALLERY_STATE_KEY = 'galleryListState';
const GALLERY_BACK_INTENT_KEY = 'galleryBackIntent';
const HOT_STATE_KEY = 'weeklyHotState';
const HOT_BACK_INTENT_KEY = 'weeklyHotBackIntent';
const PROMO_STATE_KEY = 'promoBoardState';
const PROMO_BACK_INTENT_KEY = 'promoBackIntent';
const STATE_TTL = 15 * 60 * 1000; // 15분 공통 TTL

function getAgentDeviceInfo() {
  const match = / APP_YUBI\/([^\/]+)\/(\d+)\/(\S+)/.exec(window.navigator.userAgent);
  if (match === null || match === undefined)
    return {app_os: 'WEB', app_buildNo: null, app_version: null}
  return {
    app_os: match[1], // AOS , IOS , WEB
    app_buildNo: match[2],
    app_version: match[3]
  }
}

new Vue({
  el: '#homebase',
  data: function () {
    return {
      manage_type: 'participant',
      promoParents: null,
      qsMap: {},
      mainName: '커뮤니티',
      approveOnly: false,
      inputLabel: '',
      showMode: '',
      memberLabel: '',
      selectedSubject: '',
      selectedSubjectNm: '',
      prefixLabel: '',
      scopeLabel: '',
      typeLabel: '',
      placeholderForCreate: '소속',
      fildVdList: [],
      mhbList: [],
      idp: 1,
      idx: 1,
      fpt: '',
      rc: 1,
      rm: 1,
      rc1: 1,
      rm1: 1,
      isGalleryRestored: false,
      isHotRestored: false,
      isPromoRestored: false,
      copm: {
        badgeCount: 0,
        list: [],
        detail: {}
      },
      mypageSearch: {
        auth: {
          list: [
            {
              "name": "권한전체",
              "code": "ALL"
            },
            {
              "name": "동아리장",
              "code": "HBATHYNV000110"
            },
            {
              "name": "임원",
              "code": "HBATHYNV000120"
            },
            {
              "name": "동아리원",
              "code": "HBATHYNV000130"
            }
          ],
          selected: {
            "name": "권한전체",
            "code": "ALL"
          }
        },
        searchKeyword: ''
      },
      minuteLabel: '00',
      secondLabel: '00',
      selectHbModelType: '',
      selectHbModelMemberType: '',
      selectHbModelPrefixType: '',
      selectHbModelPrefixText: '', // 말머리 selectbox
      selectHbModelPrefixEtcText: '', // 말머리 입력
      selectHbModelScopeType: '',
      selectHbModelGalleryType: '',
      selectMinute: "00",
      selectSecond: "00",
      isExpInfo: true,
      isDetailSearch: false,
      isShare: false,
      detailOption: {},
      li: [],
      videoRes: {},
      searchModel: {
        startDate: '',
        endDate: '',
        subStartDate: '',
        subEndDate: '',
        searchKword: '',
        searchOrder: 'hit',
        searchOption: '',
        searchSubject: '',
        searchCode: '',
        searchPage: 10,
        delYn: ''
      },
      myLi: 'hit',
      naviLi: 'new',
      newType: 'new',
      insertHbModel: {
        title: '',
        content: '',
        type: '',
        target: [],
        targetStr: '',
        subject: [],
        subjectStr: '',
        maxYn: 'N',
        maxCnt: 0,
        recruitType: 'always',
        centerName: ''
      },
      insertHbCntntModel: {
        brdUidKey: '',
        title: '',
        content: '',
        memberType: '',
        member: [],
        memberStr: '',
        scopeType: '',
        viewYn: '',
        lineValues: [] // 계열
      },
      insertCommunityModel: {
        brdUidKey: '',
        noticeYn: false, // 상단고정여부
        title: '',
        content: '',
        startDate: '',
        endDate: '',
        surveyList: []
      },
      insertGalleryModel: {
        brdUidKey: '',
        title: '',
        content: '',
        imgPath: ''
      },
      insertVtModel: {
        surveyVote: ''
      },
      insertReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      insertReReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      updateReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      updateReReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      insertReport: {
        reportValue: '',
        reportEtcValue: ''
      },
      insertLiveModel: {
        brdUidKey: '',
        brdTabCtg: '',
        title: '',
        content: '',
        reserveDate: '',
        reserveStartHh: '',
        reserveStartMm: '',
        reserveEndHh: '',
        reserveEndMm: '',
        reserveStartDate: '',
        reserveEndDate: '',
        reserveSurveyYn: 'Y',
        startDate: '',
        endDate: '',

        isUpdate: false,
        fileVdList: [],
        progressValues: [], // 역량
        lineValues: [], // 계열
        esg: '' // esg
      },
      insertNoticeModel: {
        brdUidKey: '',
        title: '',
        content: ''
      },
      basicOptions: {
        playerOptions: [{
          height: '360',
          autoplay: true,
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            // mp4
            src: "",
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }],
          poster: ""
        }]
      },
      viewModel: {
        mynavi: {
          selectedHbAuth: '',
          hbAuth: [
            {
              'authNm': '권한전체',
              'authCd': 'all'
            },
            {
              'authNm': '동아리장',
              'authCd': 'HBATHYNV000110'
            },
            {
              'authNm': '임원',
              'authCd': 'HBATHYNV000120'
            }
            , {
              'authNm': '동아리원',
              'authCd': 'HBATHYNV000130'
            }
          ]
        },
        newType: 'new',
        showMore: true,
        showMore2: true,
        mySort: 'new',
        totalComCount: 0,
        myWholeHomeBaseList: [],
        myWholeHomeBasePager: 1,
        myWholeHomeBaseMax: 1,
        galleryListTop: [],
        myPager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.myPager.etc;
            if (_etc == 'selectRsrvFestivalList') {
              this.model.fnGetRsrvFestivalList(n);
            } else if (_etc == 'selectNoticeList') {
              this.model.fnGetMyNoticeList(n);
            } else if (_etc == 'selectMyCancleList') {
              this.model.fnGetMyHomeBaseCancleList(n);
            }
          }
        },
        onePager: { //한줄에 1개 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.onePager.etc;
            if (_etc == 'selectNoticeList') {
              this.model.fnGetNoticeList(n);
            } else if (_etc == 'selectGalleryList') {
              this.model.fnGetGalleryList(this.model.searchModel.searchCode, this.model.searchModel.searchOrder, n);
            } else if (_etc == 'selectNaviMentoList') {
              this.model.fnGetNaviMentoPagingList(n, this.naviLi);
            }
          }
        },
        onePagerTwoRow: { //한줄에 1개씩 2줄 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 2,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.onePagerTwoRow.etc;
            if (_etc == 'selectMyHomeBaseList') {
              this.model.fnGetMyHomeBaseList(this.model.searchModel.delYn, n);
            } else if (_etc == 'naviMentoGallery') {
              this.model.fnGetNaviMentoGalleryList(n);
            }
          }
        },
        oneSubPager: { //한줄에 1개 보조 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 2,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.oneSubPager.etc;
            if (_etc == 'selectMyRegHomeBaseList') {
              this.model.fnGetMyRegHomeBaseList(null, n);
            }
          }
        },
        twoPager: { //한줄에 2개 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 4,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.twoPager.etc;
            if (_etc == 'selectCommunityList') {
              this.model.fnGetCommunityList(n);
            }
          }
        },
        threePager: { //한줄에 3개 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 6,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          searchOrder: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.threePager.etc;
            if (_etc == 'selectHomeBaseList') {
              this.model.fnGetHomeBaseList(this.model.searchModel.searchSubject, n, 'hit');
            } else if (_etc == 'selectChallengeList') {
              this.model.fnGetChallengeList(null, n);
            } else if (_etc == 'selectFestivalList') {
              this.model.fnGetFestivalList(n);
            } else if (_etc == 'selectContentsList') {
              this.model.fnGetContentsList(n);
            }
          }
        },
        threeSubPager: { //한줄에 3개 보조 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 3,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.threeSubPager.etc;
            if (_etc == 'selectFestivalList') {
              this.model.fnGetMyFestivalList(n);
            }
          }
        },
        reqDelPager: { //삭제요청 동아리용 페이징
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 2,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.reqDelPager.etc;
            if (_etc == 'selectReqDelHbList') {
              this.model.fnGetReqDelHomeBaseList(null, n);
            }
          }
        },
        contentPager: { // 동아리 컨텐츠용 페이징
          isHitSort: 'new', // 인기순 정렬여부
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 9,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            this.model.fnGetContentList(n, this.model.viewModel.contentPager.isHitSort);
          }
        },
        onePagerFiveRow: { // 1페이지에 5개씩
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 5,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_purple',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.onePagerFiveRow.etc;
            if (_etc == 'naviMentoGallery') {
              this.model.fnGetNaviMentoGalleryList(n);
            }
          }
        },
        isHbIntroTab: true,
        isHbContentsTab: false,
        isHbCommunityTab: false,
        isHbMemberTab: false,
        isWrite: true,
        isWriteComplete: false,
        isCntntMember: false,
        isSurveyEnd: false,
        isReply: false,
        isReplyUpt: false,
        isReReply: false,
        isReReplyUpt: false,
        isBadge: false,
        isLike: false,
        isZzim: false,
        isReport: false,
        isSurvey: false,
        isView: false,
        agree1: false,
        agree2: false,
        regUsrYn: '',
        zzimYn: '',
        currReplyUidKey: '',
        currBrdUidKey: '',
        weekStartDate: '',
        weekEndDate: '',
        surveyTotCnt: 0,
        totalCount: 1,
        totalCountPromotion: 1,
        totalCountMyReg: 1,
        totalReplyCount: 1,
        badgeCount: 0,
        insertBadgeCount: 0,
        detail: {},
        userDetail: {},
        typeCodeList: [],
        targetCodeList: [],
        subjectCodeList: [],
        memberCodeList: [],
        prefixCodeList: [],
        scopeCodeList: [],
        scopeHmContentCodeList: [],
        communityCodeList: [],
        authCodeList: [],
        homeBaseList: [],
        myHomeBaseList: [],
        myRegHomeBaseList: [],
        memberList: [],
        usrKeyList: [],
        memberStrNameList: [],
        contentsList: [],
        contentsKeyList: [],
        contentsImgList: [],
        replyList: [],
        replyDepthZero: [],
        replyDepthOne: [],
        communityList: [],
        surveyList: [],
        surveyVoteList: [],
        regBoardList: [],
        galleryList: [],
        galleryList1: [],
        gallerySubjectCodeList: [],
        weeklyHotList: [],
        weeklyImageList: [],
        weeklyHotKeyList: [],
        reportCodeList: [],
        reportList: [],
        noticeList: [],
        challengeList: [],
        challengeImgList: [],
        challengeHotList: [],
        challengeHotImgList: [],
        memberAuthList: [],
        updateAuthList: [],
        festivalList: [],
        festivalImgList: [],
        myFestivalList: [],
        hourList: [],
        minuteList: [],
        fileEtcList: [],
        fileImgList: [],
        fileVdList: [],
        fileVdThumList: [], // 영상 업로드 시, 자동 생성된 썸네일 목록
        fileThumList: [],
        fileUserThumList: [],
        listMinute: [],
        listSecond: [],
        newContents: [],

        totalCountReqDel: 0,
        reqDelHbList: [],

        mainSubject: "",
        affToolTpList: [ // 계열 설명
          {code: 'AFLNVADMNV001000', text: '언어학과, 국어국문학과 등 어문계열학과, 문예창작과, 철학과, 윤리학과, 국제지역학과, 지리학과, 종교학과, 문화인류학과 등'},
          {
            code: 'AFLNVADMNV002000',
            text: '정치외교학과, 국제학과, 아동가족학과, 사회복지학과, 언론방송학과, 행정학과, 경찰학과, 문헌정보학과, 미디어콘텐츠학과, 법학과,심리학과 등'
          },
          {
            code: 'AFLNVADMNV003000',
            text: '경영학과, 호텔경영학과, 경제학과, 경영정보학과, 금융보험학과, 화계학과, 세무학과, 통계학과, 국제통상학과, 광고홍보학과, 부동산관리학과 등'
          },
          {code: 'AFLNVADMNV004000', text: '교육학과, 교육심리학과, 청소년교육과, 국어/영어/중국어/일어/한문/독어/불어교육과, 유아교육과, 특수교육학과 등'},
          {code: 'AFLNVADMNV005000', text: '물리학과, 화학과, 생명과학과, 지구과학과, 원예학과, 산림학과, 식품영영학과, 조리과학과, 의류학과, 천문기상학과, 해양학과 등'},
          {
            code: 'AFLNVADMNV006000',
            text: '전기공학과, 컴퓨터공학과, 기계기술학과, 건축공학과, 토목공학과, 도시공학과, 조경학과, 환경공학과, 산업공학과, 안전공학과, 신소재공학과, 자동차공학과, 화학공학과 등'
          },
          {code: 'AFLNVADMNV007000', text: '의학과, 치의학과, 한의학과, 수의학과, 약학과, 간호학과, 임상보건학과, 재활치료학과 등'},
          {code: 'AFLNVADMNV008000', text: '음악계열, 미술계열, 체육계열, 미용/뷰티계열, 응용계열'},
          {code: 'AFLNVADMNV009000', text: '자유전공학과, 자율전공학부, 융합전공연계학과 등'}
        ],
        esgToolTpLisst: [ // esg 설명
          {code: 'ESGNVMNGNV01000', text: '환경보존 및 지속가능성을 위한 실천 프로그램'},
          {code: 'ESGNVMNGNV02000', text: '청소년이 주도하는 사회참여 및 변화실천 프로그램'},
          {code: 'ESGNVMNGNV03000', text: '민주적 의사결정에 참여하고 주도적으로 소통하는 청소년자치활동'}
        ],
        cbpToolTpList: [], // 역량 설명
        naviMentoList: [], // 내비쌤 목록
        naviMentoModel: {}, // 내비쌤 상세
        naviMentoGalleryList: [], // 내비쌤이 작성한 홈베갤러리 목록
        naviMentoMeetList: [], // 내비쌤이 개설한 화상회의 목록
        lineList: [], // 계열 코드 목록
        progressList: [], // 역량 코드 목록
        esgList: [], // esg 코드 목록
        maxSurveyVote: 0, // 투표 최대 득표 수
        prefixTextList: [], // 컨텐츠/커뮤니티 말머리 목록
      }
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
    for (i = 0; i < 60; i++) {
      let _time = (i < 10) ? "0" + i : i;
      this.viewModel.listMinute.push(_time);
      this.viewModel.listSecond.push(_time);
    }
  },
  mounted: function () {
    try {
      if (window.Kakao && !Kakao.isInitialized()) {
        Kakao.init("25727a9190252a67c490a909452aecd8");
      }
    } catch (e) {}
    // galleryList 페이지에서 복원 체크
    const currentUrl = window.location.pathname;
    // weeklyHotContentsMain 페이지에서 복원 체크
    if (currentUrl === '/customer/homebase/weeklyHotContentsMain') {
      const nav = performance.getEntriesByType('navigation')[0];
      const isBack = nav && (nav.type === 'back_forward');
      const ref = document.referrer || '';
      const fromDetailPage = ref.indexOf('/customer/homebase/contentsDetail') >= 0;
      const hasBackIntent = sessionStorage.getItem(HOT_BACK_INTENT_KEY) === 'true';

      if ((isBack || fromDetailPage) && hasBackIntent) {
        this.restoreHotState();
        return;
      }
    }
    if (currentUrl === '/customer/homebase/galleryList') {
      const nav = performance.getEntriesByType('navigation')[0];
      const isBack = nav && (nav.type === 'back_forward');
      const ref = document.referrer || '';
      const fromDetailPage = ref.indexOf('/customer/homebase/galleryDetail') >= 0;
      const hasBackIntent = sessionStorage.getItem(GALLERY_BACK_INTENT_KEY) === 'true';

      if ((isBack || fromDetailPage) && hasBackIntent) {
        this.restoreGalleryState();
        return;
      }
    }

    // promotionBoard 페이지에서 복원 체크
    if (currentUrl === '/customer/homebase/board') {
      const pageName = $("#pageName").val();
      // promotionDetail 페이지가 아닌 경우만 복원 (board 목록 페이지만)
      if (pageName === 'homeBaseMain') {
        const nav = performance.getEntriesByType('navigation')[0];
        const isBack = nav && (nav.type === 'back_forward');
        const ref = document.referrer || '';
        const fromDetailPage = ref.indexOf('/customer/homebase/promotionDetail') >= 0;
        const hasBackIntent = sessionStorage.getItem(PROMO_BACK_INTENT_KEY) === 'true';

        if ((isBack || fromDetailPage) && hasBackIntent) {
          this.restorePromoState();
          return;
        }
      }
    }

    //this.viewModel.mynavi.selectedHbAuth = this.viewModel.mynavi.hbAuth[0];
    try {
      this.qsMap = CommonTools.queryStringToMap();
      //메인 - homebaseVideoList.js
      //메인제외한 나머지 페이지


      $(".mainName").before('<span class="page_tit_sm">청소년 </span>');
      this.$nextTick(function () {
        pageLoad(this);
      });
    } catch (e) {
      console.log(e);
    }
    var url = window.location;
    let params = new URLSearchParams(url.search);
    if (params.has('idx')) this.idx = params.get('idx')
    //this.fnGetAffAreaDetail();
    if (url.href.includes('homeBaseUpdateMain')) {
      if (params.has('updateIdx')) {
        if (params.get('updateIdx') == '2') {
          this.manage_type = 'participant';
        } else if (params.get('updateIdx') == '3') {
          this.manage_type = 'contents';
        }
      }
    }


    // this.fnGetMyHomebaseSessionStorage();
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  watch: {
    selectHbModelType: function (newValue, oldValue) {
      this.inputLabel = (newValue != '') ? newValue.codeName : '';
    },
    selectHbModelMemberType: function (newValue, oldValue) {
      this.memberLabel = (newValue != '') ? newValue.codeName : '';
      this.viewModel.isCntntMember = true;
      if (newValue.codeValue == 'HBCNTNTNV000120' && $('#parentsUid').val() == 'BRDNVYTHNV02400') {
        this.searchModel.searchKword = $("#nickName").val();
        this.fnGetAllMemberList("first");
        this.searchModel.searchKword = "";
      }

      // this.insertHbCntntModel.member.push({regUsrKey:$("#usrKey").val(),nickName:$("#nickName").val()});
    },
    selectHbModelPrefixType: function (newValue, oldValue) {
      this.prefixLabel = newValue.name;
    },
    selectHbModelScopeType: function (newValue, oldValue) {
      this.scopeLabel = (newValue != '') ? newValue.codeName : '';
    },
    selectHbModelGalleryType: function (newValue, oldValue) {
      this.typeLabel = (newValue != '') ? newValue.codeName : '';
    },
    selectMinute: function (newValue) {
      this.minuteLabel = newValue;
    },
    selectSecond: function (newValue) {
      this.secondLabel = newValue;
    }
  },
  methods: {
    ensureKakaoInitialized: function () {
      try {
        if (window.Kakao && !Kakao.isInitialized()) {
          Kakao.init("25727a9190252a67c490a909452aecd8");
        }
      } catch (e) {}
    },
    initPageCommon: function () {
      try {
        this.qsMap = CommonTools.queryStringToMap();
        $(".mainName").before('<span class="page_tit_sm">청소년 </span>');
        this.$nextTick(function () {
          pageLoad(this);
        });
      } catch (e) {
        console.log(e);
      }
      var url = window.location;
      let params = new URLSearchParams(url.search);
      if (params.has('idx')) this.idx = params.get('idx')
      this.ensureKakaoInitialized();
    },
    saveState: function (key, obj) {
      try {
        sessionStorage.setItem(key, JSON.stringify(obj));
      } catch (e) {
        console.error('Failed to save state for', key, e);
      }
    },
    loadState: function (key) {
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        console.error('Failed to load state for', key, e);
        return null;
      }
    },
    restoreScroll: function (y) {
      setTimeout(() => {
        window.scrollTo(0, y || 0);
      }, 100);
    },
    // fnGoHomeBaseMain:function(tabCate){ //커뮤니티 메인페이지
    //     location.href = '/customer/homebase';
    // }
    // ,
    // 커뮤니티 공지사항 관리 히스토리 백
    fnSetMyHomebaseNoticeSessionStorage() {
      let vm = this;
      let backData = [{
        pageNo: vm.viewModel.myPager.pageNo
      }];
      sessionStorage.setItem('myHomebase.notice', JSON.stringify(backData));
    },
    fnGetMyHomebaseNoticeSessionStorage() {
      let vm = this;
      let backData;

      if (sessionStorage.getItem('myHomebase.notice') != null) {
        backData = JSON.parse(sessionStorage.getItem('myHomebase.notice'));
        sessionStorage.removeItem('myHomebase.notice');

        vm.viewModel.myPager.pageNo = backData[0].pageNo;
      }
    },
    clickFunc: function (event) {

      event.target.focus();// Add me
    },
    fnGetMyMainHomeBaseList: function () {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.delYn = "N";
      param.approve = "approve";
      param.pageNo = 1;
      param.pageSize = 100;

      Axios.post("/customer/homebase/selectMyHomeBaseList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.myHomeBaseList = response.data.list;
        vm.mhbList = vm.mhbList.concat(response.data.list)
        response.data.list.forEach(function (item) {
          vm.mhbCdList.push(item.brdUidKey);
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    filterGallery:function(item) {
      let vm = this;
      vm.selectedSubject = item.codeValue;
      vm.selectedSubjectNm = item.codeName;
      vm.fnGetGalleryList2(vm.selectedSubject, null, 1);
    },
    filterMento:function(item) {
      let vm = this;
      vm.selectedSubject = item.codeValue;
      vm.selectedSubjectNm = item.codeName;
      vm.fnGetNaviMentoList(vm.selectedSubject, vm.naviLi);
    },
    //커뮤니티 메인 - 내 가입 동아리 리스트 조회
    fnGetMyMainRegHomeBaseList: function (aprv) {
      let vm = this;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.approve = aprv ? aprv : null;
      param.pageNo = vm.viewModel.oneSubPager.pageNo;
      param.pageSize = vm.viewModel.oneSubPager.rowSize;

      Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.myRegHomeBaseList = response.data.list;
        vm.mhbList = vm.mhbList.concat(response.data.list);
        response.data.list.forEach(function (item) {
          vm.mhbCdList.push(item.brdUidKey);
        });

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetMyWholeHomeBaseList: function (aprv, pageNumber) {
      aprv = this.approveOnly ? 'approve' : '';
      let vm = this;
      let param = {};
      console.log(vm.mypageSearch.auth.selected.code);
      vm.viewModel.myWholeHomeBaseList = [];
      if (vm.mypageSearch.auth.selected.code == 'HBATHYNV000120' || vm.mypageSearch.auth.selected.code == 'HBATHYNV000130') {
        let param = {};
        if (vm.mypageSearch.auth.selected.code != 'ALL') {
          param.searchOption = vm.mypageSearch.auth.selected.code;
        }
        param.searchKeyword = vm.mypageSearch.searchKeyword;
        param.usrKey = $("#usrKey").val();
        param.approve = aprv ? aprv : null
        Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
          vm.viewModel.myWholeHomeBaseMax = vm.viewModel.totalCountMyReg + response.data.totalCount;
          vm.viewModel.myWholeHomeBaseList = vm.viewModel.myWholeHomeBaseList.concat(response.data.list.slice().reverse());
        }).catch(function (ex) {
          console.log(ex);
        });
      } else {

        if (vm.mypageSearch.auth.selected.code != 'ALL') {
          param.searchOption = vm.mypageSearch.auth.selected.code;
        }
        param.searchKeyword = vm.mypageSearch.searchKeyword;
        param.usrKey = $("#usrKey").val();
        param.delYn = 'N'
        Axios.post("/customer/homebase/selectMyHomeBaseList", {homeBaseVo: param}).then(function (response) {
          vm.viewModel.totalCountMyReg = response.data.totalCount;
          vm.viewModel.myWholeHomeBaseList = response.data.list.slice().reverse();
          let param = {};
          if (vm.mypageSearch.auth.selected.code != 'ALL') {
            param.searchOption = vm.mypageSearch.auth.selected.code;
          }
          param.searchKeyword = vm.mypageSearch.searchKeyword;
          param.usrKey = $("#usrKey").val();
          param.approve = aprv ? aprv : null
          Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
            vm.viewModel.myWholeHomeBaseMax = vm.viewModel.totalCountMyReg + response.data.totalCount;
            vm.viewModel.myWholeHomeBaseList = vm.viewModel.myWholeHomeBaseList.concat(response.data.list.slice().reverse());
          }).catch(function (ex) {
            console.log(ex);
          });
        }).catch(function (ex) {
          console.log(ex);
        });
      }
    },
    fnGetMyHomeBaseNewList: function (aprv, pageNumber) {

      let vm = this;
      let param = {};

      vm.viewModel.myWholeHomeBaseList = [];


      param.usrKey = $("#usrKey").val();
      param.delYn = 'N'
      Axios.post("/customer/homebase/selectMyHomeBaseNewContentsList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCountMyReg = response.data.totalCount;
        vm.viewModel.newContents = response.data.list;
        if (response.data.totalCount == vm.viewModel.newContents.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });

    },
    fnGoDetailNewContents: function(item) {
      if(item.brdTabCtg == "HBTABCATENV000110") {
        location.href = '/customer/homebase/contentsDetail?paramUid='+item.brdUidKey+'&homeUid=undefined';
      } else {
        location.href = '/customer/homebase/communityDetail?paramUid='+item.brdUidKey+'&homeUid=undefined';
      }
    },
    fnGetMyWholeHomeBaseList2: function (aprv, pageNumber) {
      let vm = this;
      let param = {};
      console.log(vm.mypageSearch.auth.selected.code);
      vm.viewModel.myWholeHomeBaseList = [];
      if (vm.mypageSearch.auth.selected.code == 'HBATHYNV000120' || vm.mypageSearch.auth.selected.code == 'HBATHYNV000130') {
        let param = {};
        if (vm.mypageSearch.auth.selected.code != 'ALL') {
          param.searchOption = vm.mypageSearch.auth.selected.code;
        }
        param.searchKeyword = vm.mypageSearch.searchKeyword;
        param.usrKey = $("#usrKey").val();
        param.approve = aprv ? aprv : null
        Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
          vm.viewModel.myWholeHomeBaseMax = vm.viewModel.totalCountMyReg + response.data.totalCount;
          vm.viewModel.myWholeHomeBaseList = vm.viewModel.myWholeHomeBaseList.concat(response.data.list.slice().reverse());
        }).catch(function (ex) {
          console.log(ex);
        });
      } else {

        if (vm.mypageSearch.auth.selected.code != 'ALL') {
          param.searchOption = vm.mypageSearch.auth.selected.code;
        }
        param.searchKeyword = vm.mypageSearch.searchKeyword;
        param.usrKey = $("#usrKey").val();
        param.delYn = 'N'
        Axios.post("/customer/homebase/selectMyHomeBaseList", {homeBaseVo: param}).then(function (response) {
          vm.viewModel.totalCountMyReg = response.data.totalCount;
          vm.viewModel.myWholeHomeBaseList = response.data.list.slice().reverse();
          let param = {};
          if (vm.mypageSearch.auth.selected.code != 'ALL') {
            param.searchOption = vm.mypageSearch.auth.selected.code;
          }
          param.searchKeyword = vm.mypageSearch.searchKeyword;
          param.usrKey = $("#usrKey").val();
          param.approve = aprv ? aprv : null
          Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
            vm.viewModel.myWholeHomeBaseMax = vm.viewModel.totalCountMyReg + response.data.totalCount;
            vm.viewModel.myWholeHomeBaseList = vm.viewModel.myWholeHomeBaseList.concat(response.data.list.slice().reverse());
          }).catch(function (ex) {
            console.log(ex);
          });
        }).catch(function (ex) {
          console.log(ex);
        });
      }
    },
    // 홈베갤러리 리스트 히스토리 백
    fnSetGalleyMainSessionStorage() {
      const vm = this
      let backData = [{
        pageNo: vm.viewModel.onePager.pageNo
      }];
      sessionStorage.setItem('galleryMain.list', JSON.stringify(backData));
    },

    fnGetGalleyMainSessionStorage() {
      const vm = this;
      let backData;
      if (sessionStorage.getItem('galleryMain.list') != null) {
        backData = JSON.parse(sessionStorage.getItem('galleryMain.list'));
        sessionStorage.removeItem('galleryMain.list');

        vm.viewModel.onePager.pageNo = backData[0].pageNo;
      }
    },


    // 커뮤니티 관리 히스토리 백
    fnSetMyHomebaseSessionStorage: function () {
      let vm = this;

      let backData1 = [{
        pageNo: vm.viewModel.onePagerTwoRow.pageNo,
      }];
      sessionStorage.setItem('homebase.manage', JSON.stringify(backData1));

      let backData2 = [{
        pageNo: vm.viewModel.oneSubPager.pageNo,
      }];
      sessionStorage.setItem('homebase.list', JSON.stringify(backData2));

      let backData3 = [{
        pageNo: vm.viewModel.reqDelPager.pageNo,
      }];
      sessionStorage.setItem('homebase.delete', JSON.stringify(backData3));
    },

    fnGetMyHomebaseSessionStorage: function () {
      let vm = this;
      let pageNo1;
      let pageNo2;
      let pageNo3;

      if (sessionStorage.getItem('homebase.manage') != null) {
        pageNo1 = JSON.parse(sessionStorage.getItem('homebase.manage'));
        sessionStorage.removeItem('homebase.manage');

        let _pageNo = pageNo1[0].pageNo;
        vm.viewModel.onePagerTwoRow.pageNo = _pageNo;
      }

      if (sessionStorage.getItem('homebase.list') != null) {
        pageNo2 = JSON.parse(sessionStorage.getItem('homebase.list'));
        sessionStorage.removeItem('homebase.list');

        let _pageNo = pageNo2[0].pageNo;
        vm.viewModel.oneSubPager.pageNo = _pageNo;
      }

      if (sessionStorage.getItem('homebase.delete') != null) {
        pageNo3 = JSON.parse(sessionStorage.getItem('homebase.delete'));
        sessionStorage.removeItem('homebase.delete');

        let _pageNo = pageNo3[0].pageNo;
        vm.viewModel.reqDelPager.pageNo = _pageNo;
      }

    },
    fnGoHomeBaseInsertMain: function () {
      location.href = '/customer/homebase/homeBaseInsertMain';
    },
    fnGoHomeBaseUpdateMain: function (uid) { //동아리 관리 페이지
      location.href = '/customer/homebase/homeBaseUpdateMain?paramUid=' + uid;
    },
    fnGoHomeBaseDetail: function (uid) { //동아리 상세 페이지
      location.href = '/customer/homebase/homeBaseDetail?paramUid=' + uid;
    },

    fnGoHomeBaseMain: function () {
      let searchSubject = this.mainSubject;

      if (searchSubject == "all" || searchSubject == null || searchSubject == undefined) {
        location.href = '/customer/homebase?tabIdx=joinclub';
      } else {
        location.href = '/customer/homebase?tabIdx=joinclub&searchSubject=' + searchSubject;
      }

    },
    fnGoContentsInsertMain: function (uid, parentsUid) { //동아리 컨텐츠 업로드 페이지
      if (parentsUid === undefined) parentsUid = "";
      location.href = '/customer/homebase/contentsInsertMain?paramUid=' + uid + "&parentsUid=" + parentsUid;
    },
    fnGoContentsDetail: function (uid, homeUid) { //홈베 컨텐츠 상세 페이지
      // 뒤로가기 URL이 있는 경우, 잠시 temp에 보관
      // ㄴ URL이 있는채로 상세화면 진입 시, 뒤로가기하면 커뮤니티 메인으로 돌아가버리는 문제가 발생하므로 잠시 temp로 이동
      /*      const tmpUrlForBack = sessionStorage.getItem("URL")
            if (tmpUrlForBack != null) {
              sessionStorage.setItem("TEMPURL", tmpUrlForBack);
              sessionStorage.removeItem("URL");
            }*/
      // 주간 HOT 목록 상태를 상세 진입 직전에 저장
      try {
        if (typeof this.saveHotState === 'function') {
          this.saveHotState();
        }
      } catch (e) {
        console.error('[Hot] failed to save state before detail:', e);
      }
      // weeklyHot 복원 플래그 설정
      sessionStorage.setItem(HOT_BACK_INTENT_KEY, 'true');
      location.href = '/customer/homebase/contentsDetail?paramUid=' + uid + "&homeUid=" + homeUid
    },
    fnGoCommunityInsertMain: function (uid, parentsUid, flag) { //동아리 커뮤니티 등록/수정 페이지
      if (parentsUid === undefined) parentsUid = "";
      if (flag === undefined) flag = "";
      location.href = '/customer/homebase/communityInsertMain?paramUid=' + uid + "&parentsUid=" + parentsUid + "&paramFlag=" + flag;
    },
    fnGoCommunityDetail: function (uid, homeUid) { //동아리 커뮤니티 상세 페이지
      // 뒤로가기 URL이 있는 경우, 잠시 temp에 보관
      // ㄴ URL이 있는채로 상세화면 진입 시, 뒤로가기하면 커뮤니티 메인으로 돌아가버리는 문제가 발생하므로 잠시 temp로 이동
      /*      const tmpUrlForBack = sessionStorage.getItem("URL")
            if (tmpUrlForBack != null) {
              sessionStorage.setItem("TEMPURL", tmpUrlForBack);
              sessionStorage.removeItem("URL");
            }*/
      location.href = '/customer/homebase/communityDetail?paramUid=' + uid + "&homeUid=" + homeUid;
    },
    fnGoCommunitySurvey: function (uid) { //동아리 커뮤니티 투표 페이지
      location.href = '/customer/homebase/communitySurvey?paramUid=' + uid;
    },
    fnGoGalleryMain: function (codeValue) { //홈베갤러리 페이지
      if (codeValue == null || codeValue == undefined || codeValue == "") {
        location.href = '/customer/homebase/galleryMain';
      } else {
        location.href = '/customer/homebase/galleryMain?tab=' + codeValue;
      }
    },
    fnGoNaviMentoMain: function (codeValue) { // 홈배내비샘 페이지
      if (codeValue == null || codeValue === "") {
        location.href = '/customer/homebase/naviMentoMain';
      } else {
        location.href = '/customer/homebase/naviMentoMain?tab=' + codeValue;
      }
    },
    fnGoGalleryInsertMain: function (uid) { //홈베갤러리 개설 페이지
      location.href = '/customer/homebase/galleryInsertMain?paramUid=' + uid;
    },
    fnGoGalleryDetail: function (uid) { //홈베갤러리 상세 페이지
      // 상세로 넘어가기 직전 현재 스크롤/검색 상태를 저장한다.
      try {
        if (typeof this.saveGalleryState === 'function') {
          this.saveGalleryState();
        }
      } catch (e) {
        console.error('[Gallery] failed to save state before detail:', e);
      }
      sessionStorage.setItem(GALLERY_BACK_INTENT_KEY, 'true');
      location.href = '/customer/homebase/galleryDetail?paramUid=' + uid;
    },
    fnGoWeeklyHotContentsMain: function () { //주간 HOT 페이지
      location.href = '/customer/homebase/weeklyHotContentsMain';
    },
    fnGoNoticeMain: function () { //공지사항 페이지
      location.href = '/customer/homebase/noticeMain';
    },
    fnGoNoticeDetail: function (uid) { //공지사항 상세 페이지
      this.fnSetMyHomebaseNoticeSessionStorage();
      location.href = '/customer/homebase/noticeDetail?paramUid=' + uid;
    },
    fnGoEventDetail: function (uid) { //이벤트 상세 페이지
      location.href = '/customer/realinfo/eventAnnounce?uidKey=' + uid;
    },
    fnGoChallengeMain: function () { //60초 챌린지 페이지
      // 챌린지 메인 진입 시에는 별도 백 인텐트 설정 없음 (상세에서만 설정)
      location.href = '/customer/homebase/challengeMain';
    },
    fnGoLiveFestivalMain: function () { //Live 축제 페이지
      location.href = '/customer/homebase/liveFestivalMain';
    },
    fnGoLiveFestivalCenterMain: function (uid) { //(기관마이내비) Live 축제 페이지 이동
      location.href = '/customer/homebase/liveFestivalMain?paramUid=' + uid;
    },
    fnGoLiveFestivalVodMain: function () { //Live 축제 다시보기 페이지
      location.href = '/customer/homebase/liveFestivalVodMain';
    },
    fnGoLiveFestivalVodDetail: function (uid) { //Live 축제 상세보기 페이지
      if (uid === undefined) uid = "";
      location.href = '/customer/homebase/liveFestivalVodDetail?paramUid=' + uid;
    },
    fnGoMyHomeBaseMain: function () { //마이내비 - 동아리 관리 페이지
      if ($("#smlCode").val() === "USRNVYTHNV00212") { // 청소년지도자
        location.href = '/youthnavi/mypage/center/homebase/myHomeBaseMain';
      } else if ($("#grpCode").val() == "USRNVYTHNV00100") { //사용자
        location.href = '/youthnavi/mypage/user/homebase/myHomeBaseMain';
      } else if ($("#grpCode").val() == "USRNVYTHNV00200") { //기관
        location.href = '/youthnavi/mypage/center/homebase/myHomeBaseMain';
      }
    },
    fnGoMyLiveFestivalInsertMain: function (uid) { //마이내비 - Live 축제 예약하기 페이지
      if (uid === undefined) uid = "";
      location.href = '/youthnavi/mypage/center/homebase/myLiveFestivalInsertMain?paramUid=' + uid;
    },
    fnGoMyLiveFestivalInsertVod: function (uid) { //마이내비 - 온라인축제 영상등록 페이지
      if (uid === undefined) uid = "";
      location.href = '/youthnavi/mypage/center/homebase/myLiveFestivalInsertVod?paramUid=' + uid;
    },
    fnGoMyLiveFestivalDetail: function (uid) { //마이내비 - Live 축제 상세보기 페이지
      if (uid === undefined) uid = "";
      location.href = '/youthnavi/mypage/center/homebase/myLiveFestivalDetail?paramUid=' + uid;
    },
    fnGoMyNoticeInsertMain: function (uid) { //마이내비 - 공지사항 작성 페이지
      this.fnSetMyHomebaseNoticeSessionStorage();
      if (uid === undefined) uid = "";
      location.href = '/youthnavi/mypage/center/homebase/myNoticeInsertMain?paramUid=' + uid;
    },
    fnOnChangeDurTime: function () {
      this.detailOption.durTime = "00:" + this.selectMinute + ":" + this.selectSecond;
      DropVideo.methods.selectDurTime(this.detailOption);
    },
    /*============================================================ 조회 start ========================================================================*/
    //동아리 개설 구분, 대상, 권한 코드 조회
    fnGetCodeList: function (searchCode) {
      let vm = this;
      let param = {};
      param.searchCode = searchCode ? searchCode : "HBCRTYTHNV" //구분, 대상

      Axios.post("/customer/homebase/selectCodeList", {homeBaseVo: param}).then(function (response) {
        response.data.list.forEach(function (codeObj) {
          //구분
          if (codeObj.codeGroup == "HBCRTYTHNV00100") {
            vm.viewModel.typeCodeList.push(codeObj);
            console.log(vm.viewModel.typeCodeList)
          }
          //대상
          if (codeObj.codeGroup == "HBCRTYTHNV00200") {
            vm.viewModel.targetCodeList.push(codeObj);
          }
          //권한
          if (codeObj.codeGroup == "HBATHYNV000100") {
            vm.viewModel.authCodeList.push(codeObj);
          }
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 계열 / 홈베갤러리 계열 코드 조회
    fnGetSubjectCodeList: function () {
      let vm = this;
      let param = {
        searchGroupCode: "AFLNVADMNV000000", //계열의 대분류코드값 (이게 없으면 계열 상세 코드도 조회됨)
        searchCode: "AFLNVADMNV" //계열
      };
      Axios.post("/customer/homebase/selectCodeList", {homeBaseVo: param}).then(function (response) {
        //같이 담으면 subjectCodeList에도 자유갤러리 추가됨. forEach로 분리함.
        vm.viewModel.subjectCodeList = response.data.list;

        let gallerySubjectCodeList = [];
        vm.viewModel.subjectCodeList.forEach(function (item) {
          gallerySubjectCodeList.push(item);
        });
        //gallerySubjectCodeList.push({codeValue: 'HBGALLSBJCTNV000100', codeName: '자유갤러리'});
        vm.viewModel.gallerySubjectCodeList = gallerySubjectCodeList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //홈베갤러리 타입 코드 조회
    fnGetGalleryTypeCodeList: function () {
      let vm = this;
      let param = {
        searchCode: "HBGALLTYPNV" //타입
      };
      Axios.post("/customer/homebase/selectCodeList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.typeCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 컨텐츠 업로드 코드 조회
    fnGetContentsCodeList: function () {
      let vm = this;
      let param = {
        searchCode: "HBCNTNTNV" //컨텐츠 참여자, 공개범위
      };
      // JZpNEFiAnoObnjVSpWSHrfiTuybXGo
      Axios.post("/customer/homebase/selectCodeList", {homeBaseVo: param}).then(function (response) {
        response.data.list.forEach(function (codeObj) {
          //참여자
          if (codeObj.codeGroup == "HBCNTNTNV000100") {
            vm.viewModel.memberCodeList.push(codeObj);
          }
          //공개범위
          if (codeObj.codeGroup == "HBCNTNTNV000200") {
            vm.viewModel.scopeCodeList.push(codeObj);
          }
        });

        // 동아리 컨텐츠 등록시 선택 가능한 공개범위
        const scopeHmContentCodes = [
          'HBCNTNTNV000220', /* 전체공개 */
          'HBCNTNTNV000250', /* 멤버공개 */
          'HBCNTNTNV000240', /* 비공개   */
        ]

        vm.viewModel.scopeHmContentCodeList = scopeHmContentCodes.map(code =>
          response.data.list?.find(i => i.codeValue === code)
        )

      }).catch(function (ex) {
        console.log(ex);
      });

      const preParam = {
        version: 'front',
        prefixItem: {
          brd_sub_ctg: 'BRDNVYTHNV02400', // 60초챌린지
        }
      }
      // 60초 챌린지 말머리 조회
      Axios.post("/api/homebase/prefix/list", preParam).then(function (response) {
        vm.viewModel.prefixCodeList = response.data.prefixList;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 커뮤니티 코드 조회
    fnGetCommunityCodeList: function () {
      let vm = this;
      let param = {};
      param.searchCode = "HBCMNTYNV"; //커뮤니티
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = $("#parentsUid").val();

      let smlCd = $('#smlCode').val();
      // ---------- 알통정보멘토 ----------------- 인플루언서 ------------ 진로동기부여 홈베갤러리 내비쌤 ------ 교사
      if (smlCd === 'USRNVYTHNV00122' || smlCd === 'USRNVYTHNV00123' || smlCd === 'USRNVYTHNV00124' || smlCd === 'USRNVYTHNV00125') {
        param.searchOption = "all"
      }

      Axios.post("/customer/homebase/selectCommunityCodeList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.typeCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetPrefixTextList: async function (name) { // 컨텐츠/커뮤니티 말머리 조회
      const res = await Axios.post("/api/homebase/prefix/get_txt", {configName: name})
      let text = res.data.configValue;

      // 각 줄의 시작과 끝에 있는 공백을 제거하고 줄바꿈으로 나눈 후, 비어있지 않은 줄만 배열에 포함시킵니다.
      this.viewModel.prefixTextList = text.split(/\r?\n/)
        .map(line => line.trim()) // 각 줄의 양쪽 공백을 제거
        .filter(line => line.length > 0); // 비어있는 줄은 제거

      // 기타가 없으면 추가
      if (this.viewModel.prefixTextList.findIndex(txt => txt === '기타') < 0) {
        this.viewModel.prefixTextList.push('기타');
      }
    },
    fnSetSelectModelPrefixText(prefixTxt) { // 컨텐츠/커뮤니티 말머리 select box 값 선택
      let vm = this;

      if (prefixTxt == null || prefixTxt === '') { // 빈값인 경우, '선택' 으로
        vm.selectHbModelPrefixText = '';
        vm.selectHbModelPrefixEtcText = '';
        return;
      }

      const pidex = vm.viewModel.prefixTextList.findIndex(txt => txt === prefixTxt)
      if (pidex < 0) { // selectbox에 없으면 기타로 지정
        vm.selectHbModelPrefixText = '기타';
        vm.selectHbModelPrefixEtcText = prefixTxt;
      } else {
        vm.selectHbModelPrefixText = prefixTxt;
      }
    },
    //동아리 리스트 조회
    fnGetHomeBaseList: function (searchSubject, pageNumber, searchOrder) {
      let vm = this;
      vm.viewModel.threePager.pageNo = pageNumber ? pageNumber : 1;
      vm.searchModel.searchSubject = searchSubject;

      if (searchOrder != null && searchOrder != '') {
        vm.viewModel.threePager.searchOrder = searchOrder;
        vm.viewModel.newType = searchOrder;
      }

      let param = {};
      param.searchSubject = vm.searchModel.searchSubject;
      param.pageNo = vm.viewModel.threePager.pageNo;
      param.pageSize = vm.viewModel.threePager.rowSize;
      param.searchKeyword = vm.searchModel.searchKword;
      console.log(vm.searchModel.searchKword, param.searchKeyword);
      if (vm.viewModel.threePager.searchOrder != null) {
        param.searchOrder = vm.viewModel.threePager.searchOrder;
      }

      Axios.post("/customer/homebase/selectHomeBaseList", {homeBaseVo: param}).then(function (response) {
        console.log("homebase data", response.data);
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.homeBaseList = response.data.list;
        vm.viewModel.homeBaseList.forEach(function (homebase) {
          if (homebase.recruitYn == 'Y') {
            homebase.recruitName = "모집";
          } else if (homebase.recruitYn == 'N') {
            homebase.recruitName = "마감";
          }
        });
        vm.fnSetPager(vm.viewModel.totalCount, "selectHomeBaseList", vm.viewModel.threePager);

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //내 개설 동아리 리스트 조회
    fnGetMyHomeBaseList: function (delYn, pageNumber) {
      let vm = this;
      vm.viewModel.onePagerTwoRow.pageNo = pageNumber ? pageNumber : 1;
      vm.searchModel.delYn = delYn;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.delYn = vm.searchModel.delYn;
      param.searchOrder = "insertDate";
      param.pageNo = vm.viewModel.onePagerTwoRow.pageNo;
      param.pageSize = vm.viewModel.onePagerTwoRow.rowSize;

      Axios.post("/customer/homebase/selectMyHomeBaseList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.myHomeBaseList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectMyHomeBaseList", vm.viewModel.onePagerTwoRow);

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //내 가입 동아리 리스트 조회
    fnGetMyRegHomeBaseList: function (aprv, pageNumber) {
      let vm = this;
      vm.viewModel.oneSubPager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.approve = aprv ? aprv : null
      param.pageNo = vm.viewModel.oneSubPager.pageNo;
      param.pageSize = vm.viewModel.oneSubPager.rowSize;

      Axios.post("/customer/homebase/selectMyRegHomeBaseList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCountMyReg = response.data.totalCount;
        vm.viewModel.myRegHomeBaseList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCountMyReg, "selectMyRegHomeBaseList", vm.viewModel.oneSubPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 신청자/참여자 리스트 조회
    fnGetHomeBaseMemberList: function (aprv, parentsUid) {
      let vm = this;
      let param = {};
      param.brdUidKey = parentsUid ? parentsUid : $("#paramUid").val();
      param.approve = aprv;

      Axios.post("/customer/homebase/selectMemberList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.memberList = response.data.list;
        vm.viewModel.memberList.forEach(function (member) {
          vm.viewModel.usrKeyList.push(member.regUsrKey);
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 참여자 권한 리스트 조회
    fnGetHomeBaseAuthList: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();

      Axios.post("/customer/homebase/selectMemberAuthList", {homeBaseVo: param}).then(function (response) {
        console.log("참여자 권한", response.data.list);
        vm.viewModel.memberAuthList = response.data.list;

        if (vm.viewModel.memberAuthList != null) {
          vm.viewModel.memberAuthList.forEach(function (auth) {
            let obj = {};
            obj.brdUidKey = auth.brdUidKey;
            obj.usrKey = auth.usrKey;
            obj.hbAuth = auth.hbAuth;
            obj.nickName = auth.nickName;
            obj.name = auth.name;
            obj.memo = auth.memo; // 특이사항
            vm.viewModel.updateAuthList.push(obj);
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //전체사용자 리스트 조회
    fnGetAllMemberList: function (flag) {
      let vm = this;
      let param = {};
      param.searchKeyword = vm.searchModel.searchKword;


      if (vm.searchModel.searchKword == null || vm.searchModel.searchKword == "") {
        swal("검색어를 입력해주세요.");
        return false;
      }

      Axios.post("/customer/homebase/selectAllMemberList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.memberList = response.data.list;
        console.log("전체 멤버", response.data.list);
        if (flag == "first") {
          let chkMmemberList = [];
          if (vm.viewModel.memberList != null) {
            vm.viewModel.memberList.forEach(function (mbr, index) {
              if (mbr.regUsrKey == $("#usrKey").val()) {
                chkMmemberList.push(mbr);
              }
            });
          }
          vm.insertHbCntntModel.member = chkMmemberList;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 상세조회
    fnGetHomeBaseDetail: function (updateFlag) {
      // if($("#usrKey").val() == null || $("#usrKey").val() == ""){
      //     swal("로그인 후 이용해주세요.").then(result => {
      //         location.href = '/youthnavi/signup/login';
      //     });
      //     return false;
      // }
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/homebase/selectHomeBaseDetail", {homeBaseVo: param}).then(function (response) {
        console.log(response);
        vm.viewModel.detail = response.data.homeBaseVo;
        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;

        //수정/뱃지를 위한 값 세팅
        if (vm.viewModel.detail.brdTabCtg == "HBTABCATENV000110") { //컨텐츠
          vm.insertHbCntntModel = response.data.homeBaseVo;
        } else if (vm.viewModel.detail.brdTabCtg == "HBTABCATENV000120") { //커뮤니티
          vm.insertCommunityModel = response.data.homeBaseVo;
          vm.insertCommunityModel.noticeYn = response.data.homeBaseVo.noticeYn === 'Y'
          vm.fnSetSelectModelPrefixText(response.data.homeBaseVo.prefixTxt) // 말머리
        } else if (vm.viewModel.detail.brdSubCtg == "BRDNVYTHNV02500") { //마이내비 - 공지사항
          vm.insertNoticeModel = response.data.homeBaseVo;
        } else { //동아리
          vm.insertHbModel = response.data.homeBaseVo;
          let hb = vm.viewModel.detail;
          let usrKey = $("#usrKey").val();
          if (hb.recruitYn == "Y") { //모집가능
            hb.isDisabled = true;
            if ((hb.maxYn == "Y" && hb.maxCnt == hb.memberCnt) || (vm.viewModel.usrKeyList.indexOf(usrKey) > -1)) {
              //정원이 다 찰경우 + 기가입일 경우
              hb.isDisabled = false;
            }
          } else if (hb.recruitYn == "N") { //모집불가능
            hb.isDisabled = false;
          }
        }
        //수정 시 selectbox 세팅
        if (vm.viewModel.typeCodeList != null) {
          vm.viewModel.typeCodeList.forEach(function (object) {
            if (object.codeValue == response.data.homeBaseVo.type) {
              vm.selectHbModelType = object;
            }
          });
        }
        if (vm.viewModel.scopeCodeList != null) {
          vm.viewModel.scopeCodeList.forEach(function (object) {
            if (object.codeValue == response.data.homeBaseVo.scopeType) {
              vm.selectHbModelScopeType = object;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //동아리 가입여부 조회
    fnGetHomeBaseRegYn: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.regUsrKey = $("#usrKey").val();

      Axios.post("/customer/homebase/selectHomeBaseRegYn", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.regUsrYn = response.data.homeBaseVo.regUsrYn;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 컨텐츠 리스트 조회
    fnGetContentsList: function (pageNumber, searchOrder) {

      let vm = this;
      vm.viewModel.threePager.pageNo = pageNumber ? pageNumber : 1;
      if (vm.viewModel.threePager.pageNo == 1) {
        vm.viewModel.contentsList = [];
        vm.viewModel.contentsImgList = [];
      }
      let param = {};
      param.brdSubCtg = $("#paramUid").val();
      param.pageNo = vm.viewModel.threePager.pageNo;
      param.pageSize = 4;
      param.usrKey = $("#usrKey").val();
      if (vm.searchModel.searchKword != null && vm.searchModel.searchKword != '') {
        param.searchKeyword = vm.searchModel.searchKword;
      }
      if (searchOrder != null) {
        param.searchOrder = searchOrder;
        vm.viewModel.mySort = searchOrder;
      }
      Axios.post("/customer/homebase/selectContentsList", {homeBaseVo: param}).then(function (response) {
        let _list = response.data.list;
        let _img = response.data.fileImgList;
        // 2022.11.09 썸네일 이미지 경로를 쿼리에서 만들어오는 것으로 수정하여 아래소스는 주석처리 함. (.img 대신 .fileLink 를 사용해야함)
        // if(_img != null){
        //     _img.forEach(function(item, idx){
        //         if(item != null){
        //             item.img = '/video/' +  item.file_new_name.substring(0,8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
        //         }
        //     });
        // }
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.contentsList = vm.viewModel.contentsList.concat(_list);
        vm.viewModel.contentsImgList = vm.viewModel.contentsImgList.concat(_img);
        vm.rm = Math.min(5, Math.ceil(response.data.list.length / 4))
        vm.fnSetPager(vm.viewModel.totalCount, "selectContentsList", vm.viewModel.threePager);

        if (response.data.totalCount == vm.viewModel.contentsList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 컨텐츠 상세조회
    fnGetContentsDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/homebase/selectHomeBaseDetail", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.badgeCount = response.data.resultCount;
        vm.viewModel.detail = response.data.homeBaseVo;
        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;
        vm.viewModel.fileVdThumList = response.data.thumFileList; // 다중 썸네일 목록
        vm.viewModel.fileThumList = response.data.fileThumList;
        vm.viewModel.fileUserThumList = response.data.fileUserThumList;

        // 60초챌린지인 경우, 기존에 지정했던 영상 시작시간을 셋팅함
        if (vm.viewModel.detail?.brdSubCtg === 'BRDNVYTHNV02400' && response.data.fileVdList != null && response.data.fileVdList.length > 0) {
          let inputString = response.data.fileVdList[0].ec_opt; //  -ss 00:00:00 -t 60
          // console.log("기존 인코딩 옵션 = " + inputString)

          // 정규 표현식을 사용하여 시:분:초 형식 찾기
          let timePattern = /(\d{2}):(\d{2}):(\d{2})/;
          let match = inputString?.match(timePattern);

          if (match) {
            // match[1]은 시, match[2]는 분, match[3]은 초
            vm.selectMinute = match[2];
            vm.selectSecond = match[3];
          }
        }


        if (vm.viewModel.detail.memberStrName != null) {
          vm.viewModel.memberStrNameList = vm.viewModel.detail.memberStrName.split(",");
        }

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });

        // 2022.11.09 동아리 콘텐츠에 사진도 업로드할 수 있도록 하면서 viewModel.fileImgList가 사진용으로 쓰이게됨.
        // 썸네일을 viewModel.fileImgList에 넣고 있었는데 이것을 사용하는 곳은 없었고, 사진과 썸네일이 섞이지 않게하기 위해 주석처리함.
        //썸네일리스트 이미지리스트에 추가
        // vm.viewModel.fileThumList.forEach(function(file){
        //     file.fileUrl = "/video/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name.split(".")[0] + ".png";
        //     vm.viewModel.fileImgList.push(file);
        // });

        //온라인축제 상세보기
        if (vm.viewModel.detail.brdSubCtg == "BRDNVYTHNV02600" && vm.viewModel.detail.brdTabCtg != "BRDNVYTHNV02610") {
          vm.viewModel.detail.livePath = "/liveVideo/" + vm.viewModel.detail.licUidKey + '.mp4'
        } else if (vm.viewModel.detail.brdSubCtg == "BRDNVYTHNV02600" && vm.viewModel.detail.brdTabCtg == "BRDNVYTHNV02610") {
          vm.viewModel.detail.livePath = vm.viewModel.fileVdList[0].fileUrl
        }

        setTimeout(() => {
          //수정 시 값 세팅
          vm.insertHbCntntModel = vm.viewModel.detail;

          let chkMmemberList = [];
          if (vm.viewModel.memberList != null) {
            vm.viewModel.memberList.forEach(function (mbr, index) {
              if (vm.viewModel.detail.member != null) {
                if (vm.viewModel.detail.member.indexOf(mbr.regUsrKey) > -1) {
                  chkMmemberList.push(mbr);
                }
              }
            });
          }
          vm.insertHbCntntModel.member = chkMmemberList;

          //수정 시 selectbox 세팅
          if (vm.viewModel.memberCodeList != null) {
            vm.viewModel.memberCodeList.forEach(function (object) {
              if (object.codeValue == response.data.homeBaseVo.memberType) {
                vm.selectHbModelMemberType = object;
              }
            });
          }
          if (vm.viewModel.scopeCodeList != null) {
            vm.viewModel.scopeCodeList.forEach(function (object) {
              if (object.codeValue == response.data.homeBaseVo.scopeType) {
                vm.selectHbModelScopeType = object;
              }
            });
          }

          // 60초챌린지(BRDNVYTHNV02400)이고, 계열 값이 있는 경우
          if ($("#parentsUid").val() === 'BRDNVYTHNV02400' && vm.viewModel.detail.subjectStr != null && vm.viewModel.detail.subjectStr !== '') {
            vm.insertHbCntntModel.lineValues = vm.viewModel.detail.subjectStr.split("|")
          } else {
            vm.insertHbCntntModel.lineValues = [] // 초기화
          }

          vm.fnSetPrefixSelect(response.data.homeBaseVo.prefixNo, response.data.homeBaseVo.prefixName) // 60초챌린지 말머리 셋팅

          // 컨텐츠용 말머리
          vm.fnSetSelectModelPrefixText(response.data.homeBaseVo.prefixTxt) // 말머리
        }, 50);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnSetPrefixSelect: function (pNo, pName) { // 수정 시, 60초챌린지 말머리 폼 셋팅
      let vm = this;
      if (pNo == null || pNo < 1) return; // 기존의 말머리 key가 없으면 아무일도 안함.

      // select-box option 과 동일하게 셋팅
      const preItem = {
        cmm_uid: pNo,
        name: pName,
      }

      // prefixCodeList 는 사용중이고, 기간이 유효한 것만 조회해온 결과이므로
      // 수정하는 게시글의 말머리 항목이 없을 수도 있음.
      // 없다면 임의로 만들어서 넣어줌.
      if (vm.viewModel.prefixCodeList == null || vm.viewModel.prefixCodeList.length < 1) {
        vm.viewModel.prefixCodeList.push(preItem);
        vm.selectHbModelPrefixType = preItem
      } else {
        const pCode = vm.viewModel.prefixCodeList.find(item => item.cmm_uid === pNo);
        if (pCode === undefined) {
          vm.viewModel.prefixCodeList.push(preItem);
          vm.selectHbModelPrefixType = preItem
        } else {
          vm.selectHbModelPrefixType = pCode
        }
      }
    },
    fnGetContentsNoticeDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/homebase/selectHomeBaseNoticeDetail", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.detail = response.data.homeBaseVo;
        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;
        vm.viewModel.fileThumList = response.data.fileThumList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });


        setTimeout(() => {
          //수정 시 값 세팅
          vm.insertHbCntntModel = vm.viewModel.detail;
        }, 50);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //댓글 리스트 조회
    fnGetReplyList: function (pageNumber) {
      let vm = this;
      //vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      //param.pageNo    = vm.viewModel.pager.pageNo;
      //param.pageSize  = vm.viewModel.pager.rowSize;

      Axios.post("/customer/homebase/selectReplyList", {homeBaseReplyVo: param}).then(function (response) {
        vm.viewModel.totalReplyCount = response.data.depthZeroList.length;
        vm.viewModel.replyDepthZero = response.data.depthZeroList;
        vm.viewModel.replyDepthOne = response.data.depthOneList;
        //vm.fnSetPager(vm.viewModel.totalCount, "selectReplyList",vm.viewModel.pager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetCommunityList: function (pageNumber) {
      let vm = this;
      vm.viewModel.twoPager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdSubCtg = $("#paramUid").val();
      param.pageNo = vm.viewModel.twoPager.pageNo;
      param.pageSize = 10;
      Axios.post("/customer/homebase/selectCommunityList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.totalComCount = response.data.totalCount;
        vm.viewModel.communityList = vm.viewModel.communityList.concat(response.data.list);
        vm.rm1 = Math.min(5, Math.ceil(response.data.list.length / 4))

        vm.fnSetPager(vm.viewModel.totalCount, "selectCommunityList", vm.viewModel.twoPager);
        if (response.data.totalCount == vm.viewModel.communityList.length) {
          vm.viewModel.showMore2 = false;
        } else {
          vm.viewModel.showMore2 = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetPromotionList: function (pageNumber) {
      let vm = this;

      // 복원 완료 상태라면 API 호출 스킵
      if (vm.isPromoRestored) {
        vm.isPromoRestored = false; // 플래그 리셋
        return;
      }

      vm.viewModel.twoPager.pageNo = pageNumber ? pageNumber : 1;
      if (pageNumber === 1) {
        vm.viewModel.communityList = [];
      }
      let param = {};
      param.brdSubCtg = $("#paramUid").val();
      param.pageNo = vm.viewModel.twoPager.pageNo;
      param.pageSize = 10;

      param.searchKeyword = vm.searchModel.searchKword;
      Axios.post("/customer/homebase/selectPromotionList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.totalCountPromotion = response.data.totalCount;
        vm.viewModel.communityList = vm.viewModel.communityList.concat(response.data.list);


        vm.fnSetPager(vm.viewModel.totalCount, "selectCommunityList", vm.viewModel.twoPager);

        if (response.data.totalCount == vm.viewModel.communityList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }

        // 상태 저장
        vm.savePromoState();
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //이미지태그 삭제
    fnRemoveImgTag: function (value) {
      let content = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span|\/strong|strong|\/h1|h1|\/h2|h2|\/h3|h3)([^>]*)>/gi, "");
      if (content == null) {
        return '';
      }
      return content;
    },
    //동아리 커뮤니티 상세조회(투표) 조회
    fnGetCommunitySurvey: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;
      console.log(param);
      Axios.post("/customer/homebase/selectCommunitySurvey", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.detail = response.data.list[0];
        vm.viewModel.detail.startDate = vm.viewModel.detail.startDate.replaceAll('-', '.');
        vm.viewModel.detail.endDate = vm.viewModel.detail.endDate.replaceAll('-', '.');
        vm.viewModel.surveyList = response.data.list;
        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileVdList = response.data.fileVdList;
        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        //득표율(백분율)
        vm.viewModel.surveyList.forEach(function (survey) {
          if (vm.viewModel.detail.surveyVoteTotCnt > 0) {
            let votePer = survey.surveyVoteCnt / vm.viewModel.detail.surveyVoteTotCnt * 100;
            survey.surveyVoteClass = votePer.toFixed(0);
            survey.surveyVotePer = votePer.toFixed(1);
          }
        });

        //설문 진행 여부 세팅
        let today = vm.dateFormatter(new Date());
        let endDate = vm.dateFormatter(vm.viewModel.detail.endDate);
        vm.viewModel.isSurveyEnd = today > endDate;
        if (vm.viewModel.isSurveyEnd) {
          vm.viewModel.detail.cateClass = "bg_black";
          vm.viewModel.detail.cateName = "설문종료";
          //투표 순서 정렬
          vm.viewModel.surveyList.sort(function (a, b) {
            return b.surveyVoteCnt - a.surveyVoteCnt;
          });
        } else {
          if (vm.viewModel.detail.surveyVoteTotCnt > 0) {
            vm.viewModel.detail.cateClass = "bg_purple";
            vm.viewModel.detail.cateName = "설문 진행중";
          } else {
            vm.viewModel.detail.cateClass = "bg_blue";
            vm.viewModel.detail.cateName = "설문 전";
          }
        }

        // 최대 득표 수 구하기
        const voteCntList = vm.viewModel.surveyList.map((item) => item.surveyVoteCnt)
        vm.maxSurveyVote = Math.max(...voteCntList);

        //수정을 위한 값 세팅
        if ($("#paramFlag").val() == "survey") {
          vm.insertCommunityModel = vm.viewModel.detail;
          vm.insertCommunityModel.startDate = new Date(vm.viewModel.detail.startDate);
          vm.insertCommunityModel.endDate = new Date(vm.viewModel.detail.endDate);
          vm.insertCommunityModel.surveyList = response.data.list;

          setTimeout(() => {
            //수정 시 selectbox 세팅
            if (vm.viewModel.typeCodeList != null) {
              vm.viewModel.typeCodeList.forEach(function (object) {
                if (object.codeValue == vm.viewModel.detail.type) {
                  vm.selectHbModelType = object;
                }
              });
            }
          }, 50);
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 커뮤니티 투표내역 조회
    fnGetSurveyVote: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/homebase/selectSurveyVote", {homeBaseVo: param}).then(function (response) {
        //복수설문(사용x)
        /*
                let surveyVote = [];
                response.data.list.forEach(function(vote,index){
                    surveyVote.push(vote.surveyContentKey);
                });

                if(response.data.list.length > 0){
                    vm.insertVtModel.surveyVote = surveyVote;
                    vm.viewModel.detail.surveyVote = surveyVote;
                }
                vm.viewModel.surveyVoteList = response.data.list;
                */
        //단일 설문
        if (response.data.list != null) {
          vm.insertVtModel.surveyVote = response.data.list[0].surveyContentKey;
          vm.viewModel.surveyVoteList = response.data.list;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    // 내 동아리 게시글 가져오기
    fnGetMyBoardList: function (pageNumber) {
      let vm = this;
      vm.viewModel.myBoardList = [];
      vm.viewModel.myBoardImgList = [];

      let param = {};
      param.brdSubCtg = $("#paramUid").val();
      param.pageNo = 1;
      param.withoutApprove = 'y';
      console.log(param);
      Axios.post("/customer/homebase/selectContentsList", {homeBaseVo: param}).then(function (response) {
        let _list = response.data.list;
        let _img = response.data.fileImgList;
        if (_img != null) {
          _img.forEach(function (item, idx) {
            if (item != null) {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
            }
          });
        }
        vm.viewModel.myBoardList = vm.viewModel.myBoardList.concat(_list);
        vm.viewModel.myBoardImgList = vm.viewModel.myBoardImgList.concat(_img);
        let list = [];
        vm.viewModel.myBoardList.forEach(function (item) {
          list.push(item.brdUidKey);
        });
        vm.viewModel.myBoardKeyList = list;
        console.log("my board", vm.viewModel.myBoardList);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetMyCommunityList: function () {
      let vm = this;

      let param = {};
      param.brdSubCtg = $("#paramUid").val();
      param.pageNo = 1;
      Axios.post("/customer/homebase/selectCommunityList", {homeBaseVo: param}).then(function (response) {

        vm.viewModel.totalComCount = response.data.totalCount;
        vm.viewModel.communityList = vm.viewModel.communityList.concat(response.data.list);

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //동아리 게시글 승인요청 리스트
    fnGetRegBoardList: function () {
      let vm = this;
      let param = {};
      param.brdSubCtg = $("#paramUid").val();

      Axios.post("/customer/homebase/selectRegBoardList", {homeBaseVo: param}).then(function (response) {
        // response.data.list.forEach(function(regBoard){
        //     if(regBoard.viewYn == "Y"){
        //         regBoard.viewName = "노출";
        //     }else if(regBoard.viewYn == "N"){
        //         regBoard.viewName = "미노출";
        //     }else{
        //         regBoard.viewName = "-";
        //     }
        // });
        vm.viewModel.regBoardList = response.data.list;
        console.log("게시글", response.data.list);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //메인페이지 홈베갤러리 리스트
    fnGetMainGalleryList: function (order) {
      let vm = this;
      let param = {};
      param.searchOrder = order ? order : "ai";

      Axios.post("/customer/homebase/selectMainGalleryList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.galleryListTop = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //홈베갤러리 리스트
    fnGetGalleryList: function (codeValue, order, pageNumber) {
      let vm = this;
      vm.viewModel.onePager.pageNo = pageNumber ? pageNumber : 1;
      vm.searchModel.searchCode = codeValue;
      vm.searchModel.searchOrder = order;

      let param = {};
      param.subjectStr = codeValue ? codeValue : $("#tab").val();
      param.searchOrder = order ? order : "insertDate";
      param.pageNo = vm.viewModel.onePager.pageNo;
      param.pageSize = vm.viewModel.onePager.rowSize;

      vm.fnGetNaviMentoList(param.subjectStr, 'new'); // 내비쌤 조회

      Axios.post("/customer/homebase/selectGalleryList", {homeBaseVo: param}).then(function (response) {
        console.log(response.data.list)
        response.data.list.forEach(function (item) {
          switch (item.type) {
            case 'HBGALLTYPNV000120':
              item.cateClass = 'ques';
              break; //질문
            case 'HBGALLTYPNV000130':
              item.cateClass = 'worry';
              break; //고민있어요
            case 'HBGALLTYPNV000140':
              item.cateClass = 'cooper';
              break; //협업해요
            default:
              item.cateClass = '';
          }
        });
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.galleryList = response.data.list;
        // vm.fnSetPager(vm.viewModel.totalCount, "selectGalleryList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetGalleryList1: function (codeValue, order, pageNumber) {
      let vm = this;
      vm.viewModel.onePager.pageNo = pageNumber ? pageNumber : 1;
      vm.searchModel.searchCode = codeValue;
      vm.searchModel.searchOrder = order;

      let param = {};
      param.subjectStr = codeValue ? codeValue : $("#tab").val();
      param.searchOrder = order ? order : "insertDate";
      param.pageNo = vm.viewModel.onePager.pageNo;
      param.pageSize = 30;
      param.searchKeyword = vm.searchModel.searchKword;

      // vm.fnGetNaviMentoList(param.subjectStr); // 내비쌤 조회

      Axios.post("/customer/homebase/selectGalleryList", {homeBaseVo: param}).then(function (response) {
        console.log(response.data.list)
        response.data.list.forEach(function (item) {
          switch (item.type) {
            case 'HBGALLTYPNV000120':
              item.cateClass = 'ques';
              break; //질문
            case 'HBGALLTYPNV000130':
              item.cateClass = 'worry';
              break; //고민있어요
            case 'HBGALLTYPNV000140':
              item.cateClass = 'cooper';
              break; //협업해요
            default:
              item.cateClass = '';
          }
        });
        // vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.galleryList = response.data.list;
        vm.rm = Math.min(5, Math.ceil(vm.viewModel.galleryList.length / 3))
        // vm.fnSetPager(vm.viewModel.totalCount, "selectGalleryList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetGalleryList2: function (codeValue, order, pageNumber) {
      let vm = this;

      // 복원 완료 상태라면 API 호출 스킵
      if (vm.isGalleryRestored) {
        vm.isGalleryRestored = false; // 플래그 리셋
        return;
      }

      vm.viewModel.onePager.pageNo = pageNumber ? pageNumber : 1;
      vm.searchModel.searchCode = codeValue;
      vm.searchModel.searchOrder = order;

      let param = {};
      param.subjectStr = codeValue ? codeValue : $("#tab").val();
      param.searchOrder = order ? order : "insertDate";
      param.pageNo = vm.viewModel.onePager.pageNo;
      param.pageSize = 10;
      param.searchKeyword = vm.searchModel.searchKword;

      // vm.fnGetNaviMentoList(param.subjectStr); // 내비쌤 조회
      if(pageNumber == 1) {
        vm.viewModel.galleryList1 = [];
      }
      Axios.post("/customer/homebase/selectGalleryList", {homeBaseVo: param}).then(function (response) {

        response.data.list.forEach(function (item) {
          switch (item.type) {
            case 'HBGALLTYPNV000120':
              item.cateClass = 'ques';
              break; //질문
            case 'HBGALLTYPNV000130':
              item.cateClass = 'worry';
              break; //고민있어요
            case 'HBGALLTYPNV000140':
              item.cateClass = 'cooper';
              break; //협업해요
            default:
              item.cateClass = '';
          }
        });
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.galleryList1 = vm.viewModel.galleryList1.concat(response.data.list);
        vm.rm1 = Math.min(5, Math.ceil(vm.viewModel.galleryList1.length / 3))

        // 상태 저장
        vm.saveGalleryState();
        // vm.fnSetPager(vm.viewModel.totalCount, "selectGalleryList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //진로그라운드 리스트 화면 리스트
    fnGetGalleryList3: function (pageNumber) {
      let vm = this;
      if (pageNumber < 1) vm.viewModel.galleryList1 = [];
      vm.viewModel.onePager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.pageNo = vm.viewModel.onePager.pageNo;
      param.pageSize = 10;
      param.searchKeyword = vm.searchModel.searchKword;

      // vm.fnGetNaviMentoList(param.subjectStr); // 내비쌤 조회

      Axios.post("/customer/homebase/selectGalleryList", {homeBaseVo: param}).then(function (response) {
        console.log(response.data.list)
        response.data.list.forEach(function (item) {
          switch (item.type) {
            case 'HBGALLTYPNV000120':
              item.cateClass = 'ques';
              break; //질문
            case 'HBGALLTYPNV000130':
              item.cateClass = 'worry';
              break; //고민있어요
            case 'HBGALLTYPNV000140':
              item.cateClass = 'cooper';
              break; //협업해요
            default:
              item.cateClass = '';
          }
        });
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.galleryList1 = vm.viewModel.galleryList1.concat(response.data.list);
        vm.rm1 = Math.min(5, Math.ceil(vm.viewModel.galleryList1.length / 3))
        // vm.fnSetPager(vm.viewModel.totalCount, "selectGalleryList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //홈베갤러리 상세조회
    fnGetGalleryDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/homebase/selectGalleryDetail", {homeBaseVo: param}).then(function (response) {
        let item = response.data.homeBaseVo;
        switch (item.type) {
          case 'HBGALLTYPNV000120':
            item.cateClass = 'ques';
            break; //질문
          case 'HBGALLTYPNV000130':
            item.cateClass = 'worry';
            break; //고민있어요
          case 'HBGALLTYPNV000140':
            item.cateClass = 'cooper';
            break; //협업해요
          default:
            item.cateClass = 'line';
        }
        vm.viewModel.detail = item;
        vm.insertGalleryModel = item;
        vm.viewModel.fileImgList = response.data.fileImgList;


        //수정 시 selectbox 세팅
        if (vm.viewModel.gallerySubjectCodeList != null) {
          vm.viewModel.gallerySubjectCodeList.forEach(function (object) {
            if (object.codeValue == vm.viewModel.detail.subjectStr) {
              vm.selectHbModelType = object;
            }
          });
        }
        if (vm.viewModel.typeCodeList != null) {
          vm.viewModel.typeCodeList.forEach(function (object) {
            if (object.codeValue == vm.viewModel.detail.type) {
              vm.selectHbModelGalleryType = object;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //주간 HOT 리스트
    fnGetWeeklyHotList: function (pageNumber) {
      let vm = this;

      if (pageNumber == 1) {
        vm.viewModel.weeklyHotList = [];
        vm.viewModel.weeklyImageList = [];
      }

      let param = {};
      //param.searchOption = 'weekly'
      param.searchOrder = 'ai'
      param.pageNo = 1;
      param.pageSize = 9;

      Axios.post("/customer/homebase/selectContentsList", {homeBaseVo: param}).then(function (response) {
        let _list = response.data.list;
        let _img = response.data.fileImgList;
        if (_img != null) {
          _img.forEach(function (item, idx) {
            if (item != null) {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
            }
          });
        }
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.weeklyHotList = vm.viewModel.weeklyHotList.concat(_list);
        vm.viewModel.weeklyImageList = vm.viewModel.weeklyImageList.concat(_img);

        let list = [];
        vm.viewModel.weeklyHotList.forEach(function (item) {
          list.push(item.brdUidKey);
        });
        vm.viewModel.weeklyHotKeyList = list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGoToQna() {
      var _userKey = $('#usrKey').val();
      if (_userKey == null || _userKey == "") {
        swal({
          text: "문의하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=/customer/notice/qna";
          }
        });
      } else {
        location.href = '/customer/notice/qna'
      }
    },
    fnGoToWriteGallery() {
      var _userKey = $('#usrKey').val();
      if (_userKey == null || _userKey == "") {
        swal({
          text: "진로고민 해결소 글쓰기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=/customer/homebase/galleryInsertMain?paramUid=";
          }
        });
      } else {
        location.href = '/customer/homebase/galleryInsertMain?paramUid='
      }
    },
    // 동아리 컨텐츠
    fnGetContentList: function (pageNumber, isHitSort) {
      let vm = this;
      // 복원 완료 상태라면 API 호출 스킵
      if (vm.isHotRestored) {
        vm.isHotRestored = false; // 플래그 리셋
        return;
      }
      vm.viewModel.contentPager.pageNo = pageNumber ? pageNumber : 1;
      vm.viewModel.contentPager.isHitSort = isHitSort;



      let param = {};
      // param.searchOption = 'weekly' // 해당 옵션 사용 시, 최근 2주의 컨텐츠만 조회함
      param.searchOption = 'club_all_content' // 모든 동아리 컨텐츠
      // param.searchOrder  = 'hit' // 해당 옵션 사용 시, 인기순. 미사용시, 최신순
      //param.searchOrder = isHitSort ? 'hit' : '' // 해당 옵션 사용 시, 인기순. 미사용시, 최신순
      param.searchOrder = vm.viewModel.contentPager.isHitSort;
      param.pageNo = vm.viewModel.contentPager.pageNo;
      param.pageSize = 8;
      param.searchKeyword = vm.searchModel.searchKword; //검색 기능 추가

      if (isHitSort == 'myClub') {
        let keyword = '';
        let cnt = 0;
        vm.mhbList.forEach(function (item) {
          if (cnt > 0) {
            keyword += ','
          }
          keyword += item.brdUidKey;
          cnt++;
        });
        param.pageSize = 8;
        param.searchOrder = vm.viewModel.contentPager.isHitSort;
        param.searchOption = keyword;
        console.log("Keyword", keyword);
      }

      Axios.post("/customer/homebase/selectContentsList", {homeBaseVo: param}).then(function (response) {
        let _list = response.data.list;
        let _img = response.data.fileImgList;
        // 2022.11.09 썸네일 이미지 경로를 쿼리에서 만들어오는 것으로 수정하여 아래소스는 주석처리 함. (.img 대신 .fileLink 를 사용해야함)
        // if(_img != null){
        //     _img.forEach(function(item, idx){
        //         if(item != null){
        //             item.img = '/video/' +  item.file_new_name.substring(0,8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
        //         }
        //     });
        // }
        vm.viewModel.totalCount = response.data.totalCount;
        if (pageNumber == 1) {
          vm.viewModel.contentsList = _list;
          vm.viewModel.contentsImgList = _img;
        } else {
          vm.viewModel.contentsList = vm.viewModel.contentsList.concat(_list);
          vm.viewModel.contentsImgList = vm.viewModel.contentsImgList.concat(_img);
        }

        let list = [];
        vm.viewModel.contentsList.forEach(function (item) {
          list.push(item.brdUidKey);
        });
        vm.viewModel.contentsKeyList = list;

        // vm.fnSetPager(vm.viewModel.totalCount, "selectContentList", vm.viewModel.contentPager);
        vm.viewModel.contentPager.totalSize = response.data.totalCount;
        vm.viewModel.contentPager.pageNum = (vm.viewModel.contentPager.pageNo * vm.viewModel.contentPager.rowSize) - vm.viewModel.contentPager.rowSize;

        if (response.data.totalCount == vm.viewModel.contentsList.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
        // 상태 저장
        vm.saveHotState();
        // Pager.props = Pager.methods.createPager(vm.viewModel.contentPager, vm, "list");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    extractContent(s) {
      var span = document.createElement('span');
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },
    //신고 사유 조회
    fnGetReportCodeList: function () {
      let vm = this;
      Axios.post("/customer/homebase/selectReportCodeList", {homeBaseVo: {}}).then(function (response) {
        vm.viewModel.reportCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //좋아요/신고 조회
    fnGetReportList: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/homebase/selectReportList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.reportList = response.data.list;

        if (vm.viewModel.reportList != null) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100" && report.likeYn == "Y") { //좋아요
              vm.viewModel.isLike = true;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 찜 여부 조회
    fnGetHomeBaseZzimYn: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/homebase/selectHomeBaseZzimYn", {homeBaseVo: param}).then(function (response) {
        if (response.data.homeBaseVo != null && response.data.homeBaseVo != "") {
          vm.viewModel.zzimYn = response.data.homeBaseVo.zzimYn;
          if (vm.viewModel.zzimYn == 'Y') {
            vm.viewModel.isZzim = true;
          } else if (vm.viewModel.zzimYn == 'N') {
            vm.viewModel.isZzim = false;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 공지사항 리스트
    fnGetNoticeList: function (pageNumber) {
      let vm = this;
      vm.viewModel.onePager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.pageNo = vm.viewModel.onePager.pageNo;
      param.pageSize = vm.viewModel.onePager.rowSize;

      Axios.post("/customer/homebase/selectNoticeList", {homeBaseVo: param}).then(function (response) {
        if (response.data.list != null) {
          response.data.list.forEach(function (item) {
            item.content = vm.fnOnLoadKakaoContent(item.content)
          });
        }

        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.noticeList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectNoticeList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 60초 챌린지 리스트
    fnGetChallengeList: function (searchOrder, pageNumber) {
      let vm = this;
      vm.viewModel.threePager.pageNo = pageNumber ? pageNumber : 1;
      vm.chalLi = searchOrder;
      let param = {};
      if (searchOrder == "hit") {
        param.pageNo = 1;
        param.pageSize = 5;
        param.searchOrder = searchOrder;
      } else {
        param.pageNo = vm.viewModel.threePager.pageNo;
        param.pageSize = vm.viewModel.threePager.rowSize;
      }

      Axios.post("/customer/homebase/selectChallengeList", {homeBaseVo: param}).then(function (response) {
        let _list = response.data.list;
        let _img = response.data.fileImgList;

        let param = {};
        let urlAddress = '';
        Axios.post("/api/url/address", param).then(function (response) {
          urlAddress = response.data.urlName;
          if (_list != null) {
            _list.forEach(function (item) {
              item.checked = false;
            });
          }
          if (_img != null) {
            _img.forEach(function (item, idx) {
              if (item != null) {
                item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
                item.video = urlAddress + "/video/" + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.mp4';
              }
            });
          }
        });

        vm.viewModel.challengeHotList = _list;
        vm.viewModel.challengeHotImgList = _img;
        vm.viewModel.challengeList = response.data.list;
        vm.viewModel.challengeImgList = _img;
        if (searchOrder == "hit") {

        } else {
          vm.viewModel.totalCount = response.data.totalCount;

          vm.fnSetPager(vm.viewModel.totalCount, "selectChallengeList", vm.viewModel.threePager);
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 온라인축제 리스트
    fnGetFestivalList: function (pageNumber) {
      let vm = this;
      vm.viewModel.threePager.pageNo = pageNumber ? pageNumber : 1;
      vm.viewModel.threePager.rowSize = 3;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.pageNo = vm.viewModel.threePager.pageNo;
      param.pageSize = vm.viewModel.threePager.rowSize;

      Axios.post("/customer/homebase/selectFestivalList", {homeBaseVo: param}).then(function (response) {
        let _img = response.data.fileImgList;
        if (_img != null) {
          _img.forEach(function (item, idx) {
            if (item != null) {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
            }
          });
        }

        if (response.data.list != null) {
          response.data.list.forEach(function (item) {
            if (item.brdTabCtg == 'BRDNVYTHNV02610') item.livePath = '/video/' + item.fileNewName.substr(0, 8) + '/' + item.fileNewName.split('.')[0] + '.mp4';
            if (item.brdTabCtg != 'BRDNVYTHNV02610') item.livePath = '/liveVideo/' + item.licUidKey + '.mp4'
          });
        }

        vm.viewModel.isSurvey = false;
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.festivalList = response.data.list;
        vm.viewModel.festivalImgList = _img;
        vm.fnSetPager(vm.viewModel.totalCount, "selectFestivalList", vm.viewModel.threePager);

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 온라인축제 참여 리스트
    fnGetMyFestivalList: function (pageNumber) {
      let vm = this;
      vm.viewModel.threeSubPager.pageNo = pageNumber ? pageNumber : 1;
      vm.fnOnClickOffSurvey();

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.pageNo = vm.viewModel.threeSubPager.pageNo;
      param.pageSize = vm.viewModel.threeSubPager.rowSize;

      Axios.post("/customer/homebase/selectMyRegLiveList", {homeBaseVo: param}).then(function (response) {
        let now = new Date();

        if (response.data.list != null) {
          response.data.list.forEach(function (item) {
            item.livePath = '/liveVideo/' + item.licUidKey + '.mp4'
            //만족도조사 마감 여부 - 만족도조사 종료일과 비교
            let endDate = new Date(item.endDate);
            endDate.setDate(endDate.getDate() + 1);
            endDate.setHours(0);
            if (now > endDate) {
              item.surveyEndYn = 'Y';
            }
          });
        }

        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.myFestivalList = response.data.list;
        console.log("tot", vm.viewModel.totalCount);
        vm.fnSetPager(vm.viewModel.totalCount, "selectMyRegLiveList", vm.viewModel.threeSubPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 커뮤니티 온라인축제예약 리스트
    fnGetRsrvFestivalList: function (pageNumber) {
      let vm = this;
      vm.viewModel.myPager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.pageNo = vm.viewModel.myPager.pageNo;
      param.pageSize = 10;

      Axios.post("/customer/homebase/selectRsrvFestivalList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.festivalList = response.data.list;

        let now = new Date();

        vm.viewModel.festivalList.forEach(function (item) {
          //라이브 시작버튼 노출여부 결정
          // if(now > new Date(item.reserveEndDate)){
          //     item.liveStartYn = 'N';
          // }

          if (item.approve == "approve") {
            item.approveClass = "font_blue";
            item.approveStr = "승인완료";
            if (item.status == "ready") {
              item.statusClass = "font_gray";
              item.statusStr = "진행전";
            } else if (item.status == "run") {
              item.statusClass = "font_orange";
              item.statusStr = "진행중";
            } else if (item.status == "end") {
              item.statusClass = "font_blue";
              item.statusStr = "진행완료";
            }
          } else if (item.approve == "ready") {
            item.approveClass = "font_gray";
            item.approveStr = "승인대기";
          } else if (item.approve == "reject") {
            item.approveClass = "font_red";
            item.approveStr = "반려";
          }
        });
        vm.fnSetPager(vm.viewModel.totalCount, "selectRsrvFestivalList", vm.viewModel.myPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 온라인축제 설문 리스트
    fnGetFestivalSurvey: function (uid) {
      let vm = this;

      // let param = {};
      //     param.brdUidKey = $("#paramUid").val();

      let param = {};
      param.uidKey = $("#paramUid").val();

      if (uid != null && uid != "") {
        param.uidKey = uid;
        vm.viewModel.isSurvey = true;
        vm.viewModel.currBrdUidKey = uid;
      }

      Axios.post("/mynavi/user/survey/info", param).then(function (response) {
        vm.viewModel.isSurvey = true;
        vm.viewModel.currBrdUidKey = uid;
        vm.viewModel.surveyList = response.data.surveyList;

        // vm.$refs.refSurvey.fnSetSurveyList(surveyList);

        vm.viewModel.surveyList.forEach(function (item) {
          item.brdUidKey = uid;
          if (item.code == 'MEANVSURNV00100') {
            item.name = '5점척도';
          } else if (item.code == 'MEANVSURNV00200') {
            item.name = '자유형객관식';
          } else if (item.code == 'MEANVSURNV00300') {
            item.name = '주관식';
          }

          item.contentList = [];
          let list = item.value.split("|");
          list.forEach(function (items, index) {
            item.contentList.push({idx: index, content: items, checked: "N"});
          });
        });
      }).catch(function (ex) {
        console.log(ex);
      });

      // Axios.post("/customer/homebase/selectFestivalSurvey", {homeBaseVo:param}).then(function(response) {
      //     /* 형식
      //         [ { name: '5점척도', code : 'MEANVSURNV00100', text:'', value:'매우그렇다|그렇다|보통이다|아니다|매우아니다.', isChecked:false}
      //         , { name: '자유형객관식', code : 'MEANVSURNV00200', text:'', value:'', isChecked:false}
      //         , { name: '주관식', code : 'MEANVSURNV00300', text:'', value:'', isChecked:false} ]
      //     */
      //     let surveyList = [];
      //     if(response.data.list.length > 0){
      //         response.data.list.forEach(function(item){
      //             let name = "";
      //             if(item.type == "MEANVSURNV00100"){
      //                 name = "5점척도"
      //             }else if(item.type == "MEANVSURNV00200"){
      //                 name = "자유형객관식"
      //             }else if(item.type == "MEANVSURNV00300"){
      //                 name = "주관식"
      //             }

      //             let obj = {};
      //             obj.name      = name;
      //             obj.code      = item.type;
      //             obj.text      = item.title;
      //             obj.value     = item.content;
      //             obj.isChecked = false;
      //             surveyList.push(obj);
      //         });
      //     }
      //     if(uid != null && uid != ""){
      //         surveyList.forEach(function(subItem){
      //             subItem.surveyItem = subItem.value.split("|");
      //         });
      //     }else{
      //         vm.$refs.refSurvey.fnSetSurveyList(surveyList);
      //     }
      //     vm.viewModel.surveyList = surveyList;
      // }).catch(function(ex) {
      //     console.log(ex);
      // });
    },
    //만족도조사 항목 조회
    fnGetFestivalSurveyList: function (uid) {
      let vm = this;

      let param = {};
      param.brdUidKey = $("#paramUid").val();

      if (uid != null && uid != "") {
        param.brdUidKey = uid;
        vm.viewModel.isSurvey = true;
        vm.viewModel.currBrdUidKey = uid;
      }

      Axios.post("/customer/homebase/selectFestivalSurvey", {homeBaseVo: param}).then(function (response) {
        /* 형식
                    [ { name: '5점척도', code : 'MEANVSURNV00100', text:'', value:'매우그렇다|그렇다|보통이다|아니다|매우아니다.', isChecked:false},
                    { name: '자유형객관식', code : 'MEANVSURNV00200', text:'', value:'', isChecked:false},
                    { name: '주관식', code : 'MEANVSURNV00300', text:'', value:'', isChecked:false} ]
                */
        let surveyList = [];
        if (response.data.list.length > 0) {
          response.data.list.forEach(function (item) {
            let name = "";
            if (item.type == "MEANVSURNV00100") {
              name = "5점척도"
            } else if (item.type == "MEANVSURNV00200") {
              name = "자유형객관식"
            } else if (item.type == "MEANVSURNV00300") {
              name = "주관식"
            }

            let obj = {};
            obj.name = name;
            obj.code = item.type;
            obj.text = item.title;
            obj.value = item.content;
            obj.isChecked = false;
            surveyList.push(obj);
          });
        }
        if (surveyList.length > 0) {
          if (uid != null && uid != "") {
            surveyList.forEach(function (subItem) {
              subItem.surveyItem = subItem.value.split("|");
            });
          } else {
            vm.$refs.refSurvey.fnSetSurveyList(surveyList);
          }
        }
        vm.viewModel.surveyList = surveyList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //설문조사 닫기 (list 초기화)
    fnOnClickOffSurvey() {
      let vm = this;
      vm.viewModel.isSurvey = false;
      vm.viewModel.surveyList = [];
    },
    //설문조사 보기 창 닫기 (list 초기화)
    fnOnClickOffSurveyView() {
      let vm = this;
      vm.viewModel.isView = false;
      vm.viewModel.surveyList = [];
    },
    //자신의 설문조사 보기(수정x)
    fnOnClickOnSurveyView(value) {
      let vm = this;
      let param = {
        uidKey: value
      };
      Axios.post("/mynavi/user/survey/view", param).then(function (response) {
        vm.viewModel.isView = true;
        vm.viewModel.surveyList = response.data.surveyList;

        vm.viewModel.surveyList.forEach(function (item) {
          item.prgmUidKey = value;
          if (item.code == 'MEANVSURNV00100') {
            item.name = '5점척도';
          } else if (item.code == 'MEANVSURNV00200') {
            item.name = '자유형객관식';
          } else if (item.code == 'MEANVSURNV00300') {
            item.name = '주관식';
          }

          if (item.code != "MEANVSURNV00300") {
            let list = item.value.split("|");
            let answerList = item.answer.split("|");
            let answer = "";

            for (let idx in answerList) {
              if (answerList[idx] == 'Y') {
                answer = answer + list[idx] + ",";
              }
            }
            answer = answer.slice(0, -1);
            item.answer = answer;
          }
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //설문조사 값 선택 후 다른값으로 바꿀 때 event
    fnOnChangeValue: function (index, list) {
      list.forEach(function (item, index) {
        item.checked = 'N';
      });
      list[index].checked = 'Y';
      //value.checked = (value.checked) ? false : true;
    },
    //설문조사 validation (안적은 값 있으면 false)
    fnValidationSurvey() {
      let vm = this;
      let success = true;

      vm.viewModel.surveyList.forEach(function (item) {
        if (item.code != "MEANVSURNV00300") { //객관식일 경우
          let count = 0;

          item.contentList.forEach(function (items) {
            let content = items.checked;
            if (content == 'N') {
              count++;
            }
          });

          if (item.contentList.length == count) {
            success = false;
          }
        } else {  //주관식일 경우
          if (item.answer.trim() == '' || item.answer.trim() == null) {
            success = false;
          }
        }
      });

      if (!success) {
        swal("설문작성이 완료되지 않았습니다.");
        return false;
      } else if (success) {
        return true;
      }

    },
    //설문조사 insert
    fnSubmitSurvey() {
      let vm = this;

      swal({
        text: "설문조사를 제출하시겠습니까? \n설문조사는 수정이 불가능합니다.",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          if (vm.fnValidationSurvey()) {
            let _uidKey = vm.viewModel.surveyList[0].brdUidKey;

            vm.viewModel.surveyList.forEach(function (item) {
              if (item.code != "MEANVSURNV00300") {
                let _answer = "";

                item.contentList.forEach(function (items) {
                  let content = items.checked;
                  _answer = _answer + content + "|";
                });

                item.answer = _answer.slice(0, -1);
              }
              delete item.contentList;
              delete item.brdUidKey;
            });

            let _string = JSON.stringify(vm.viewModel.surveyList);
            let param = {};
            param.resultData = JSON.stringify({uidKey: _uidKey, list: _string});

            Axios.post("/api/survey/insertAnswer", param).then(function (response) {
              let result = response.data.resultCount;

              if (result > 0) {
                swal({
                  text: "설문이 등록되었습니다.",
                  // icon: vm.fnOnLoadSwalImageData("success"),
                  closeOnClickOutside: false,
                  buttons: {
                    confirm: {text: "확인", value: true, visible: true},
                    cancle: {text: "취소", value: false, visible: false}
                  }
                }).then(result => {
                  if (result) {
                    location.reload();
                  }
                });
              } else if (result <= 0) {
                swal({
                  text: "오류가 발생하였습니다.",
                  // icon: this.fnOnLoadSwalImageData("error"),
                  closeOnClickOutside: false,
                  buttons: {
                    confirm: {text: "확인", value: true, visible: false},
                    cancle: {text: "취소", value: false, visible: false}
                  }
                });
              }
            });
          }
        }
      }).catch(function (ex) {
        swal({
          text: "오류가 발생하였습니다.",
          // icon: this.fnOnLoadSwalImageData("error"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: false},
            cancle: {text: "취소", value: false, visible: false}
          }
        });
      });
    },
    //sweetalert에 들어가는 사진 호출
    fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    },

    //온라인축제 상세조회
    fnGetFestivalDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/homebase/selectLiveFestivalDetail", {homeBaseVo: param}).then(function (response) {
        let detail = response.data.homeBaseVo;
        // vm.insertLiveModel = vm.viewModel.detail;
        vm.insertLiveModel.brdUidKey = detail.brdUidKey;
        vm.insertLiveModel.brdTabCtg = detail.brdTabCtg;
        vm.insertLiveModel.title = detail.title;
        vm.insertLiveModel.content = detail.content;
        vm.insertLiveModel.reserveSurveyYn = detail.reserveSurveyYn;

        vm.insertLiveModel.progressValues = (detail.progressStr != null && detail.progressStr !== "") ? detail.progressStr.split("|") : [];
        vm.insertLiveModel.lineValues = (detail.subjectStr != null && detail.subjectStr !== "") ? detail.subjectStr.split("|") : [];
        vm.insertLiveModel.esg = detail.esg;

        // 가져온 설문조사 여부가 Y이면 수정, N이면 입력 (설문조사)
        if (updateFlag == "update") {
          if (detail.reserveSurveyYn == "Y") {
            vm.insertLiveModel.isUpdate = true;
          }
        }

        vm.insertLiveModel.reserveDate = new Date(detail.reserveStartDate);

        if (detail.reserveStartDate != null) {
          vm.insertLiveModel.reserveDateFormat = detail.reserveStartDate.split(" ")[0];
          let startHhMm = detail.reserveStartDate.split(" ")[1]; //yyyy-mm-dd hh:mm:00
          let endHhMm = detail.reserveEndDate.split(" ")[1];
          vm.insertLiveModel.reserveStartHh = startHhMm.split(":")[0];
          vm.insertLiveModel.reserveStartMm = startHhMm.split(":")[1];
          vm.insertLiveModel.reserveEndHh = endHhMm.split(":")[0];
          vm.insertLiveModel.reserveEndMm = endHhMm.split(":")[1];
        }

        vm.insertLiveModel.startDate = detail.startDate; //만족도조사 시작일
        vm.insertLiveModel.endDate = detail.endDate; //만족도조사 종료일

        vm.insertLiveModel.fileVdList = response.data.fileVdList;

        if (vm.insertLiveModel.fileVdList.length > 0) {
          vm.insertLiveModel.fileVdList.forEach(function (file) {
            file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
          });
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 커뮤니티 온라인축제예약 사용자 정보 조회
    fnGetUserDetail: function () {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      Axios.post("/customer/homebase/selectUserDetail", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.userDetail = response.data.homeBaseVo;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 커뮤니티 공지사항 리스트
    fnGetMyNoticeList: function (pageNumber) {
      let vm = this;
      vm.viewModel.myPager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.pageNo = vm.viewModel.myPager.pageNo;
      param.pageSize = vm.viewModel.myPager.rowSize;

      Axios.post("/customer/homebase/selectNoticeList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.noticeList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectNoticeList", vm.viewModel.myPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 동아리 개설취소 리스트 조회
    fnGetMyHomeBaseCancleList: function (pageNumber) {
      let vm = this;
      vm.viewModel.myPager.pageNo = pageNumber ? pageNumber : 1;
      vm.viewModel.myPager.rowSize = vm.searchModel.searchPage;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.pageNo = vm.viewModel.myPager.pageNo;
      param.pageSize = vm.searchModel.searchPage;
      param.searchKeyword = vm.searchModel.searchKword;
      if (vm.isDetailSearch) {
        param.startDate = vm.dateFormatter(vm.searchModel.startDate, "-");
        param.endDate = vm.dateFormatter(vm.searchModel.endDate, "-");
      }

      Axios.post("/customer/homebase/selectMyCancleList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.myHomeBaseList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCount, "selectMyCancleList", vm.viewModel.myPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //삭제요청 동아리 리스트 조회
    fnGetReqDelHomeBaseList: function (aprv, pageNumber) {
      let vm = this;
      vm.viewModel.reqDelPager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.approve = aprv ? aprv : null
      param.pageNo = vm.viewModel.reqDelPager.pageNo;
      param.pageSize = vm.viewModel.reqDelPager.rowSize;

      Axios.post("/customer/homebase/selectReqDelHbList", {homeBaseVo: param}).then(function (response) {
        vm.viewModel.totalCountReqDel = response.data.totalCount;
        vm.viewModel.reqDelHbList = response.data.list;
        vm.fnSetPager(vm.viewModel.totalCountReqDel, "selectReqDelHbList", vm.viewModel.reqDelPager);
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    /*============================================================ 조회 end ========================================================================*/

    /*============================================================ 저장 start ========================================================================*/,
    //동아리 개설
    fnSetHomeBase: function () {
      let vm = this;

      if (vm.fnValidateChk(vm.validateArr) > 0) {
        return false;
      }

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (vm.insertHbModel.title == null || vm.insertHbModel.title.trim() == "") {
        swal("동아리 명을 입력해주세요.").then(function () {
          $('#title').focus();
        })

        return false;
      }
      if (vm.$refs.dropimg.cnt <= 0) {
        swal("대표이미지를 위해 이미지를 한 장 이상 등록해주세요.").then(function() {

          $("html, body").animate({scrollTop: $("#mainImg").offset().top-200}, 100);
        });
        return false;
      }


      if (vm.insertHbModel.content == null || vm.insertHbModel.content.trim() == "") {
        swal("동아리 소개를 입력해주세요.").then(function() {

          $("html, body").animate({scrollTop: $("#content").offset().top-200}, 100);
        });
        return false;
      }

      if (vm.selectHbModelType == null || vm.selectHbModelType == "") {
        swal("동아리 구분을 선택해주세요.").then(function () {
          $('#modelType').focus();
        });
        return false;
      }

      if (vm.insertHbModel.centerName == null || vm.insertHbModel.centerName == "") {
        swal("소속 학교/기관/단체 명을 입력해주세요.").then(function () {
          $('#centerName').focus();
        });
        return false;
      }

      if (vm.insertHbModel.target == null || vm.insertHbModel.target == "") {
        swal("대상을 하나 이상 선택해주세요.");
        return false;
      }


      if (vm.insertHbModel.subject == null || vm.insertHbModel.subject == "") {
        swal("계열을 선택해주세요.");
        return false;
      }

      if (vm.insertHbModel.maxYn == "Y" && vm.insertHbModel.maxCnt < 1) {
        swal("제한인원을 확인해주세요.").then(function () {
          $('#maxCnt').focus();
        });
        return false;
      }

      let param = {};
      param.brdSubCtg = "BRDNVYTHNV02100"; //동아리
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.title = vm.insertHbModel.title;
      param.content = vm.insertHbModel.content;
      param.type = vm.selectHbModelType.codeValue;
      param.centerName = vm.insertHbModel.centerName;
      param.targetStr = vm.insertHbModel.target.join('|');
      // param.subjectStr  = vm.insertHbModel.subject.join('|');
      param.subjectStr = vm.insertHbModel.subject;
      param.maxYn = vm.insertHbModel.maxYn;
      param.maxCnt = vm.insertHbModel.maxCnt;
      param.recruitType = vm.insertHbModel.recruitType;
      param.approve = "approve";

      Axios.post("/customer/homebase/insertHomeBase", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.fnCallImgAltSave();
          vm.viewModel.isWrite = false;
          vm.viewModel.isWriteComplete = true;
          swal({
            text: '동아리 개설이 완료되었습니다.',
            buttons: {
              confirm: {text: "확인", value: true, visible: true,},
            }
          }).then(result => {
            if (result) {
              location.href = '/customer/homebase/homeBaseDetail?paramUid='+response.data.homeBaseVo.brdUidKey;
            }
          })
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 수정
    fnUptHomeBase: function () {
      let vm = this;
      let bossLength = 0;
      if (vm.viewModel.updateAuthList != null) {
        vm.viewModel.updateAuthList.forEach(function (auth) {
          if (auth.hbAuth == "HBATHYNV000110") { //동아리장
            bossLength++;
          }
        });
      }

      if (bossLength > 1) {
        swal("동아리장은 한명만 지정해주세요.");
        return false;
      } else if (bossLength == 0) {
        swal("동아리장을 지정해주세요.");
        return false;
      }

      if (vm.insertHbModel.title == null || vm.insertHbModel.title == "") {
        swal(
          {
            text: "동아리 명을 입력해주세요",
            buttons:{
              confirm: {text: "확인", value: true, visible: true,},
            }
          }
        ).then(function () {
          $('#title').focus();
        });
        return false;
      }

      if (vm.insertHbModel.maxYn === "Y" && vm.insertHbModel.maxCnt < 1) {
        swal("제한인원을 확인해주세요.").then(function () {
          $('#maxCnt').focus();
        });
        return false;
      }

      let param = {};
      param.fileKey = $("#fileKey").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.brdUidKey = $("#paramUid").val();
      param.title = vm.insertHbModel.title;
      param.content = vm.insertHbModel.content;
      param.maxYn = vm.insertHbModel.maxYn; // 구성원 제한여부
      param.maxCnt = vm.insertHbModel.maxCnt; // 구성원 제한 수
      param.recruitType = vm.insertHbModel.recruitType; // 모집유형
      swal({
        text: "동아리 권한 변경 시 되돌릴 수 없습니다.\n진행하시겠습니까?",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/customer/homebase/updateHomeBase", {homeBaseVo: param}).then(function (response) {
            vm.fnCallImgAltSave();
            //동아리 참여자 권한 수정
            vm.fnUptHomeBaseAuth(vm.viewModel.updateAuthList);
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      }).catch(function (ex) {
      });

    },
    //동아리 참여자 권한 수정
    fnUptHomeBaseAuth: function (updateAuthList) {
      let vm = this;
      let param = {};
      param.updateAuthList = updateAuthList.length > 0 ? updateAuthList : [];

      Axios.post("/customer/homebase/updateMemberAuth", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          swal("수정되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 게시글 삭제
    fnDelHomeBase: function (uid, backCnt) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = uid;


      swal({
        text: "삭제 하시겠습니까?\n되돌릴 수 없습니다.",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/customer/homebase/deleteHomeBase", {homeBaseVo: param}).then(function (response) {
            swal("삭제되었습니다.").then(result => {
              if (backCnt == 0) {
                window.location.reload();
              } else if (backCnt == -1) {
                window.history.back();
              }
            });
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });


    },

    fnDelHomeBaseEndThis: function () {
      let brdUidKey = $('#paramUid').val();
      this.fnDelHomeBaseEnd(brdUidKey);
    },
    //동아리 최종 삭제
    fnDelHomeBaseEnd: function (uid) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = uid;

      swal({
        text: "삭제 하시겠습니까?\n되돌릴 수 없습니다.",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/customer/homebase/deleteHomeBase", {homeBaseVo: param}).then(function (response) {
            swal("삭제되었습니다.").then(result => {
              window.location.reload();
            });
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      }).catch(function (ex) {
        swal({
          text: "오류가 발생하였습니다.",
          // icon: this.fnOnLoadSwalImageData("error"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: false},
            cancle: {text: "취소", value: false, visible: false}
          }
        });
      });
    },
    fnAddSubHbCntnt: function (cd) {
      let vm = this;
      if (vm.insertHbCntntModel.lineValues.includes(cd)) {
        vm.insertHbCntntModel.lineValues = vm.insertHbCntntModel.lineValues.filter(e => e !== cd);
      } else {
        if (vm.insertHbCntntModel.lineValues.length >= 3) {
          swal("계열은 최대 3개까지 선택 가능합니다");

        } else {
          vm.insertHbCntntModel.lineValues.push(cd);
        }
      }
    },
    //동아리 컨텐츠 업로드
    fnSetHbContents: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "업로드는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      let isContentsMode = false; // 동아리 콘텐츠 모드 여부
      let memberUsrKeyList = [];
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = $("#parentsUid").val();
      param.title = vm.insertHbCntntModel.title;
      param.content = vm.insertHbCntntModel.content;
      param.viewYn     = vm.insertHbCntntModel.viewYn;
      param.memberType = vm.selectHbModelMemberType.codeValue != null ? vm.selectHbModelMemberType.codeValue : "HBCNTNTNV000110"; //기본값:개인
      param.scopeType = vm.selectHbModelScopeType.codeValue;
      param.pick_vd_thum_uid = vm.$refs.dropvideochoicethum.pick_thum_uid // 사용자가 선택한 썸네일 이미지 uid

      if ($("#parentsUid").val() != 'BRDNVYTHNV02400') { //컨텐츠
        param.brdTabCtg = "HBTABCATENV000110";
        isContentsMode = true;
        param.prefixTxt = vm.selectHbModelPrefixText === '기타' ? vm.selectHbModelPrefixEtcText : vm.selectHbModelPrefixText; // 말머리
      } else if ($("#parentsUid").val() == 'BRDNVYTHNV02400') { //60초 챌린지
        param.approve = "approve";
        param.subject = vm.insertHbCntntModel.lineValues; // 계열
        param.prefixNo = vm.selectHbModelPrefixType.cmm_uid; // 말머리 key
      }

      if (vm.selectHbModelMemberType.codeValue == 'HBCNTNTNV000120') { //팀일 경우
        vm.insertHbCntntModel.member.forEach(function (mbr) {
          memberUsrKeyList.push(mbr.regUsrKey);
        });

        param.memberStr = memberUsrKeyList.join('|');
      } else { //개인일 경우
        param.memberStr = $("#usrKey").val();
      }

      if (vm.insertHbCntntModel.title == null || vm.insertHbCntntModel.title == "") {
        swal("제목을 입력해주세요.").then(function () {
          $('#title').focus();
        });
        return false;
      }

      if (vm.insertHbCntntModel.content.indexOf("<img src=") > 0) {
        swal("콘텐츠/60초챌린지 업로드에서는 이미지를 등록할 수 없습니다.\n이미지를 삭제해주세요.");
        return false;
      }

      if (!isContentsMode) {
        if (vm.insertHbCntntModel.lineValues.length < 1) {
          swal('계열을 선택해 주세요.').then(function () {
            $("html, body").animate({scrollTop: $("#lineValues").offset().top-200}, 100);
          });
          return false;
        }
      }

      if (vm.selectHbModelMemberType.codeValue == null || vm.selectHbModelMemberType.codeValue == "") {
        swal("참여자를 설정해주세요.").then(function () {
          $('#memberCodeList').focus();
        });
        return false;
      }

      // if(vm.selectHbModelPrefixType.cmm_uid == null || vm.selectHbModelPrefixType.cmm_uid === ""){
      //     swal("말머리를 선택해 주세요.");
      //     return false;
      // }

      if (vm.selectHbModelScopeType.codeValue == null || vm.selectHbModelScopeType.codeValue == "") {
        swal("공개범위를 설정해주세요.").then(function () {
          $('#scopeHmContentCodeList').focus();
        });
        return false;
      }

      if (isContentsMode) { // 동아리 콘텐츠 (사진/영상 택 1 필수)
        if (vm.$refs.dropvideochoicethum.cnt < 1 && vm.$refs.dropimgone.cnt < 1) { // 영상, 사진 둘 다 없는 경우
          swal("사진 또는 영상을 첨부해주세요.");
          return false;
        }
        if (vm.$refs.dropvideochoicethum.cnt > 0 && vm.$refs.dropimgone.cnt > 0) { // 영상, 사진 둘 다 있는 경우
          swal("사진과 영상을 함께 등록할 수 없습니다. \n사진 또는 영상 중 하나를 삭제해주세요.");
          return false;
        }
      } else {

        if (vm.$refs.dropvideochoicethum.cnt == 0) {
          swal("영상을 첨부해주세요.");
          return false;
        }
      }

      // 동영상 업로드 상태 체크 (동영상이 업로드 중이거나 실패한 경우 등록 방지)
      if (vm.$refs.dropvideochoicethum && vm.$refs.dropvideochoicethum.cnt > 0) {
        let videoUploadStatus = vm.$refs.dropvideochoicethum.videoUploadRes;
        if (videoUploadStatus && videoUploadStatus.resValue) {
          if (videoUploadStatus.resValue === 'fail') {
            swal("업로드에 실패한 동영상이 첨부되어 있습니다. 다시 업로드해 주세요.");
            return false;
          } else if (videoUploadStatus.resValue === 'ready') {
            swal("동영상이 업로드 중입니다. 업로드 완료 후 다시 시도해 주세요.");
            return false;
          }
        }
      }

      Axios.post("/customer/homebase/insertContents", {homeBaseVo: param}).then(function (response) {
        if ($("#parentsUid").val() != 'BRDNVYTHNV02400') { //컨텐츠
          if (response.data.succCnt > 0) {
            // 동아리장
            if (response.data.auth != null && response.data.auth != '' && response.data.auth == "HBATHYNV000110") {

              swal("등록되었습니다.").then(result => {
                location.href = '/customer/homebase/contentsDetail?paramUid='+response.data.homeBaseVo.brdUidKey;
              });
            } else {
              // 20221108 조성이 팀장님 카톡으로 요청 : 동아리 장 외에 동아리원도 컨텐츠 승인과정 없이 바로 개시 ( 자동승인 )
              // swal("등록되었습니다.\n콘텐츠는 동아리장의 승인이후 게시됩니다.")

              swal("등록되었습니다.").then(result => {
                location.href = '/customer/homebase/contentsDetail?paramUid='+response.data.homeBaseVo.brdUidKey;
              });
            }
            return false;
          } else if (response.data.succCnt == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false,
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          }else{
            swal({
              text : "업로드는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
              closeOnClickOutside : false,
              buttons : {
                confirm : {
                  text : "확인",
                  value : true,
                  visible : true
                },
                cancel : {
                  text : "취소",
                  value : false,
                  visible : true
                }
              }
            }).then(result => {
              if(result){
                location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
              }
            });
            return false;
          }
        } else {
          if (response.data.succCnt > 0) {
            swal("등록되었습니다.").then(result => {
              location.href = '/customer/homebase/contentsDetail?paramUid='+response.data.homeBaseVo.brdUidKey;
            });
            return false;
          } else if (response.data.succCnt == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon: vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false,
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true,
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          }else{
            swal({
              text : "업로드는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
              closeOnClickOutside : false,
              buttons : {
                confirm : {
                  text : "확인",
                  value : true,
                  visible : true
                },
                cancel : {
                  text : "취소",
                  value : false,
                  visible : true
                }
              }
            }).then(result => {
              if(result){
                location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
              }
            });
            return false;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 컨텐츠 수정
    fnUptHbContents: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let memberUsrKeyList = [];
      let param = {};
      param.fileKey = $("#fileKey").val();
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.title = vm.insertHbCntntModel.title;
      param.content = vm.insertHbCntntModel.content;
      param.viewYn = vm.insertHbCntntModel.viewYn;
      param.memberType = vm.selectHbModelMemberType.codeValue != null ? vm.selectHbModelMemberType.codeValue : "HBCNTNTNV000110"; //기본값:개인
      param.scopeType = vm.selectHbModelScopeType.codeValue;
      param.pick_vd_thum_uid = vm.$refs.dropvideochoicethum.pick_thum_uid // 사용자가 선택한 썸네일 이미지 uid

      if ($("#parentsUid").val() === 'BRDNVYTHNV02400') { //60초 챌린지
        param.subject = vm.insertHbCntntModel.lineValues; // 계열
        param.prefixNo = vm.selectHbModelPrefixType.cmm_uid; // 말머리 key
        param.vd_dur_time = vm.detailOption.durTime // 60초챌린지 시작시간
      } else {
        param.prefixTxt = vm.selectHbModelPrefixText === '기타' ? vm.selectHbModelPrefixEtcText : vm.selectHbModelPrefixText; // 말머리
      }

      if (vm.selectHbModelMemberType.codeValue == 'HBCNTNTNV000120') { //팀일 경우
        vm.insertHbCntntModel.member.forEach(function (mbr) {
          memberUsrKeyList.push(mbr.regUsrKey);
        });
        param.memberStr = memberUsrKeyList.join('|');
      } else { //개인일 경우
        param.memberStr = $("#usrKey").val();
      }

      if (vm.insertHbCntntModel.title == null || vm.insertHbCntntModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#title').focus();
        });
        return false;
      }

      if (vm.insertHbCntntModel.content.indexOf("<img src=") > 0) {
        swal("콘텐츠/60초챌린지 업로드에서는 이미지를 등록할 수 없습니다.\n이미지를 삭제해주세요.");
        return false;
      }

      if (vm.selectHbModelScopeType.codeValue == null || vm.selectHbModelScopeType.codeValue == "") {
        swal("공개범위를 설정해주세요.").then(function () {
          $('#scopeHmContentCodeList').focus();
        });
        return false;
      }

      if ($("#parentsUid").val() !== 'BRDNVYTHNV02400') { // 동아리 콘텐츠 (사진/영상 택 1 필수)
        if (vm.$refs.dropvideochoicethum.cnt < 1 && vm.$refs.dropimgone.cnt < 1) { // 영상, 사진 둘 다 없는 경우
          swal("사진 또는 영상을 첨부해주세요.");
          return false;
        }
        if (vm.$refs.dropvideochoicethum.cnt > 0 && vm.$refs.dropimgone.cnt > 0) { // 영상, 사진 둘 다 있는 경우
          swal("사진과 영상을 함께 등록할 수 없습니다. \n사진 또는 영상 중 하나를 삭제해주세요.");
          return false;
        }
      } else {
        if (vm.insertHbCntntModel.lineValues.length < 1) {
          swal('계열을 선택해 주세요.').then(function () {
            $('#lineValues').focus();
          });
          return false;
        }

        if (vm.$refs.dropvideochoicethum.cnt == 0) {
          swal("영상을 첨부해주세요.");
          return false;
        }
      }

      if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
        if (vm.videoRes.resValue == "fail") {
          swal("업로드에 실패한 동영상이 첨부되어 있습니다.");
        } else {
          swal("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        }
        return false;
      }


      Axios.post("/customer/homebase/updateContents", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          swal("수정되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 글 작성
    fnSetCommunity: function () {
      // 로그인 체크 (공통 함수 사용 - 페이지 로드 시점에서 이미 체크하지만 안전을 위해 유지)
      if(!checkLoginRequired({ checkSimpleSignup: true })) {
        return false;
      }
      let vm = this;
      let param = {};
      param.brdSubCtg = $("#parentsUid").val();
      param.usrKey = $("#usrKey").val();
      param.noticeYn = vm.insertCommunityModel.noticeYn ? 'Y' : 'N';
      param.title = vm.insertCommunityModel.title;
      param.content = vm.insertCommunityModel.content;
      param.scopeType = vm.selectHbModelScopeType.codeValue;
      param.type = vm.selectHbModelType.codeValue;
      param.brdTabCtg = "HBTABCATENV000120"; //커뮤니티
      param.fileKey = $("#fileKey").val(); // 첨부파일 key
      param.approve = 'approve' // 2022.11.15 (요청번호: 521264) 커뮤니티는 동아리장의 승인과정 없이 바로 게시될 수 있도록 요청 (자동승인)
      param.prefixTxt = vm.selectHbModelPrefixText === '기타' ? vm.selectHbModelPrefixEtcText : vm.selectHbModelPrefixText; // 말머리


      let isContentEmpty = false;


      if (vm.selectHbModelType.codeValue == "HBCMNTYNV000160") {
        vm.insertCommunityModel.surveyList.forEach(function (survey) {
          survey.usrKey = $("#usrKey").val();
          survey.startDate = vm.dateFormatter(vm.insertCommunityModel.startDate, "-");
          survey.endDate = vm.dateFormatter(vm.insertCommunityModel.endDate, "-");
          if (survey.surveyContent == null || survey.surveyContent == '') {
            isContentEmpty = true;
          }
        });
        param.surveyList = vm.insertCommunityModel.surveyList;

        if(vm.selectHbModelPrefixText == '기타' && vm.selectHbModelPrefixEtcText.trim() == '') {

          swal("말머리를 입력해주세요.").then(function () {
            $('#prefixText').focus();
          });
          return false;
        }
        if (vm.insertCommunityModel.title == null || vm.insertCommunityModel.title == "") {
          swal("제목을 확인해주세요.").then(function () {
            $('#communityTitle').focus();
          });
          return false;
        }

        if (vm.selectHbModelScopeType.codeValue == null || vm.selectHbModelScopeType.codeValue == "") {
          swal("공개범위를 설정해주세요.").then(function () {
            $('#scopeType').focus();
          });
          return false;
        }
        if (vm.insertCommunityModel.startDate == '') {
          swal("설문 시작일을 입력해주세요").then(function() {
          });
          return false;
        }
        if (vm.insertCommunityModel.startDate == '') {
          swal("설문 종료일을 입력해주세요").then(function() {
          });
          return false;
        }
        if (vm.insertCommunityModel.startDate > vm.insertCommunityModel.endDate) {
          swal("시작일이 종료일보다 클 수 없습니다.");
          return false;
        }

        if (vm.insertCommunityModel.surveyList.length <= 1 || isContentEmpty) {
          swal("항목을 확인해주세요.").then(function () {
            $('#surveyContent').focus();
          });
          return false;
        }
      }

      if (vm.selectHbModelType.codeValue == "" || vm.selectHbModelType.codeValue == null) {
        swal("카테고리를 확인해주세요.").then(function () {
          $('#modelType').focus();
        });
        return false;
      }

      if(vm.selectHbModelPrefixText == '기타' && vm.selectHbModelPrefixEtcText.trim() == '') {

        swal("말머리를 입력해주세요.").then(function () {
          $('#prefixText').focus();
        });
        return false;
      }

      if (vm.insertCommunityModel.title == null || vm.insertCommunityModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#communityTitle').focus();
        });
        return false;
      }
      if (vm.selectHbModelType.codeValue != "HBCMNTYNV000160" && (vm.insertCommunityModel.content == "" || vm.insertCommunityModel.content == null)) {
        swal("내용을 확인해주세요.").then(function () {
          $("html, body").animate({scrollTop: $("#communityContent").offset().top-200}, 100);
        });
        return false;
      }
      if (vm.selectHbModelScopeType.codeValue == null || vm.selectHbModelScopeType.codeValue == "") {
        swal("공개범위를 설정해주세요.").then(function () {
          $('#scopeType').focus();
        });
        return false;
      }


      if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
        if (vm.videoRes.resValue === "fail") {
          swal("업로드에 실패한 동영상이 첨부되어 있습니다.");
        } else {
          swal("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        }
        return false;
      }

      Axios.post("/customer/homebase/insertCommunity", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          // swal("등록되었습니다.\n커뮤니티는 동아리장의 승인이후 게시됩니다.").then(result => {
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 글 수정
    fnUptCommunity: function () {
      // 로그인 체크 (공통 함수 사용 - 페이지 로드 시점에서 이미 체크하지만 안전을 위해 유지)
      if(!checkLoginRequired({ checkSimpleSignup: true })) {
        return false;
      }
      let vm = this;
      let paramFlag = $("#paramFlag").val();
      let isContentEmpty = false;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.noticeYn = vm.insertCommunityModel.noticeYn ? 'Y' : 'N';
      param.title = vm.insertCommunityModel.title;
      param.content = vm.insertCommunityModel.content;
      param.scopeType = vm.selectHbModelScopeType.codeValue;
      param.type = vm.selectHbModelType.codeValue;
      param.fileKey = $("#fileKey").val(); // 첨부파일 key
      param.usrKey = $("#usrKey").val();  // 첨부파일 저장 시, 사용
      param.usrId = $("#usrId").val();   // 첨부파일 저장 시, 사용
      param.prefixTxt = vm.selectHbModelPrefixText === '기타' ? vm.selectHbModelPrefixEtcText : vm.selectHbModelPrefixText; // 말머리

      //설문/투표
      if (vm.selectHbModelType.codeValue == "HBCMNTYNV000160") {
        let _paramList = [];
        vm.insertCommunityModel.surveyList.forEach(function (survey) {
          let _paramObj = {};
          _paramObj.usrKey = $("#usrKey").val();
          _paramObj.startDate = vm.dateFormatter(vm.insertCommunityModel.startDate, "-");
          _paramObj.endDate = vm.dateFormatter(vm.insertCommunityModel.endDate, "-");
          _paramObj.surveyContent = survey.surveyContent;
          if (_paramObj.surveyContent == null || _paramObj.surveyContent == '') {
            isContentEmpty = true;
          }
          _paramList.push(_paramObj);
        });
        param.surveyList = _paramList;
      }

      if (vm.insertCommunityModel.title == null || vm.insertCommunityModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#communityTitle').focus();
        });
        return false;
      }

      if (vm.selectHbModelScopeType.codeValue == null || vm.selectHbModelScopeType.codeValue == "") {
        swal("공개범위를 설정해주세요.").then(function () {
          $('#scopeType').focus();
        });
        return false;
      }

      if (vm.insertCommunityModel.startDate > vm.insertCommunityModel.endDate) {
        swal("시작일이 종료일보다 클 수 없습니다.");
        return false;
      }

      if (paramFlag == "survey") {
        if (vm.insertCommunityModel.surveyList.length <= 1 || isContentEmpty) {
          swal("항목을 확인해주세요.").then(function () {
            $('#surveyContent').focus();
          });
          return false;
        }
      } else {
        if (vm.insertCommunityModel.content == null) {
          swal("내용을 입력해주세요.").then(function () {
            $('#communityContent').focus();
          });
          return false;
        }
      }

      Axios.post("/customer/homebase/updateCommunity", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnSetPromotion: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.brdSubCtg = vm.promoParents? vm.promoParents.brdUidKey:'';
      param.usrKey = $("#usrKey").val();
      param.title = vm.insertCommunityModel.title;
      param.content = vm.insertCommunityModel.content;
      param.brdTabCtg = "HBTABCATENV000130"; //홍보보드
      param.fileKey = $("#fileKey").val(); // 첨부파일 key
      param.approve = 'approve' //  홍보보드는 바로 게시될 수 있도록 요청 (자동승인)

      let isContentEmpty = false;

      if (vm.promoParents == null) {
        swal("동아리를 선택해주세요").then(function () {
          $("html, body").animate({scrollTop: $("#myHb").offset().top-200}, 100);
        });
        return false;
      }

      if (vm.insertCommunityModel.title == null || vm.insertCommunityModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#communityTitle').focus();
        });
        return false;
      }
      if (vm.selectHbModelType.codeValue != "HBCMNTYNV000160" && (vm.insertCommunityModel.content == "" || vm.insertCommunityModel.content == null)) {
        swal("내용을 확인해주세요.").then(function () {
          $("html, body").animate({scrollTop: $("#communityContent").offset().top-200}, 100);
        });
        return false;
      }

      if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
        if (vm.videoRes.resValue === "fail") {
          swal("업로드에 실패한 동영상이 첨부되어 있습니다.");
        } else {
          swal("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        }
        return false;
      }

      Axios.post("/customer/homebase/insertCommunity", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          // swal("등록되었습니다.\n커뮤니티는 동아리장의 승인이후 게시됩니다.").then(result => {
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "Cancel",
                value: false,
                visible: false,
              },
              confirm: {
                text: "Ok",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 투표하기
    fnSetSurveyVote: function () {
      let vm = this;
      let objList = [];
      let obj = {};
      obj.brdUidKey = $("#paramUid").val();
      obj.usrKey = $("#usrKey").val();
      obj.surveyContentKey = vm.insertVtModel.surveyVote;
      objList.push(obj);
      let param = {};
      param.surveyVote = objList;

      //복수설문(사용x)
      /*
            vm.insertVtModel.surveyVote.forEach(function(item,index){
                let param = {};
                    param.brdUidKey        = $("#paramUid").val();
                    param.usrKey           = $("#usrKey").val();
                    param.surveyContentKey = item;
                    paramList.push(param);
            });
            param.surveyVote = objList;
            */

      Axios.post("/customer/homebase/insertSurveyVote", {homeBaseVo: param}).then(function (response) {
        window.location.reload();
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //홈베갤러리 글 작성
    fnSetGallery: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.brdSubCtg = "BRDNVYTHNV02300"; //홈베갤러리
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.subjectStr = vm.selectHbModelType.codeValue;
      param.type = vm.selectHbModelGalleryType.codeValue;
      param.title = vm.insertGalleryModel.title;
      param.content = vm.insertGalleryModel.content;

      // if(vm.$refs.dropimg.cnt == 0){
      //     swal("대표이미지를 넣어주세요.");
      //     return false;
      // }

      if (vm.insertGalleryModel.title == null || vm.insertGalleryModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#insertGalleryTitle').focus();
        });
        return false;
      }

      if (vm.insertGalleryModel.content == null || vm.insertGalleryModel.content == "") {
        swal("내용을 확인해주세요.").then(function () {
          $("html, body").animate({scrollTop: $("#content").offset().top-200}, 100);

        });
        return false;
      }


      Axios.post("/customer/homebase/insertGallery", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          // vm.fnCallImgAltSave();
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //홈베갤러리 글 수정
    fnUptGallery: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.brdUidKey = $("#paramUid").val();
      param.fileKey = $("#fileKey").val();
      param.subjectStr = vm.selectHbModelType.codeValue;
      param.type = vm.selectHbModelGalleryType.codeValue;
      param.title = vm.insertGalleryModel.title;
      param.content = vm.insertGalleryModel.content;
      // if(!vm.insertNewsModel.content){
      //      alert("내용을 입력해주세요.");
      //      return false;
      // }

      if (vm.insertGalleryModel.title == null || vm.insertGalleryModel.title == "") {
        swal("제목을 확인해주세요.").then(function () {
          $('#insertGalleryTitle').focus();
        });
        return false;
      }

      Axios.post("/customer/homebase/updateGallery", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.fnCallImgAltSave();
          swal("수정되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else if (response.data.succCnt == -403) {
          swal({
            title: '권한 없음',
            text: '본인이 작성한 게시글만 수정할 수 있습니다.',
            buttons: { confirm: {text: "확인", value: true, visible: true} },
            dangerMode: true
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 가입신청
    fnRegHomeBase: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if ($("#usrAge").val() != null && $("#usrAge").val() != "" && Number($("#usrAge").val()) > 24) {
        swal("24세 이하만 가입이 가능합니다.");
        return false;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.regUsrKey = $("#usrKey").val();

      if ($("#brdUsrKey").val() == $("#usrKey").val()) {
        swal("자신이 개설한 동아리는 가입할수 없습니다.");
        return false;
      }

      if (vm.viewModel.regUsrYn == 'Y') {
        swal("이미 가입했거나 신청중입니다.");
        return false;
      }
      swal({
        text : "동아리에 가입신청 하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          Axios.post("/customer/homebase/insertRegHomeBase", {homeBaseVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal("가입신청이 완료되었습니다.\n 동아리장 승인 후 가입이 완료됩니다.").then(result => {
                window.location.reload();
              });
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });

    },
    //동아리 가입 승인
    fnRegMemberApply: function (index, applyFlag) {
      let vm = this;
      console.log(vm.viewModel.memberList[index]);
      console.log(index);
      console.log(vm.viewModel.memberList);
      let hb = vm.viewModel.detail;
      if (hb.maxYn == "Y" && hb.maxCnt == hb.memberCnt) { //정원이 다 찰경우
        swal("정원이 다 찼습니다.");
        return false;
      }

      if (hb.delReqYn == "Y") { //삭제요청 중인 동아리일 경우
        swal("삭제요청중인 동아리는 가입을 승인하실수 없습니다.");
        return false;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();

      param.regUsrKey = vm.viewModel.memberList[index].regUsrKey;
      param.approve = applyFlag;

      Axios.post("/customer/homebase/applyRegMember", {homeBaseVo: param}).then(function (response) {
        vm.$set(vm.viewModel.memberList[index], 'memberApply', applyFlag);
        if (applyFlag == "approve") {
          hb.memberCnt++;
          swal("동아리가입 승인처리 되었습니다").then(result => {
            var url = window.location;
            let params = new URLSearchParams(url.search);
            if (params.has('updateIdx')) {
              params.set('updateIdx', '2');
              var new_href = url.origin + url.pathname + '?' + params.toString();
              location.href = new_href;
            } else {
              params.append('updateIdx', '2');
              var new_href = url.origin + url.pathname + '?' + params.toString();
              location.href = new_href;
            }
          });

        } else {
          swal("동아리가입 거절처리 되었습니다").then(result => {
            var url = window.location;
            let params = new URLSearchParams(url.search);
            if (params.has('updateIdx')) {
              params.set('updateIdx', '2');
              var new_href = url.origin + url.pathname + '?' + params.toString();
              location.href = new_href;
            } else {
              params.append('updateIdx', '2');
              var new_href = url.origin + url.pathname + '?' + params.toString();
              location.href = new_href;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 게시글 승인
    fnRegBoardApply: function (index, applyFlag) {
      let vm = this;
      let param = {};
      param.brdUidKey = vm.viewModel.regBoardList[index].brdUidKey;
      param.approve = applyFlag;

      Axios.post("/customer/homebase/applyRegBoard", {homeBaseVo: param}).then(function (response) {
        vm.$set(vm.viewModel.regBoardList[index], 'boardApply', applyFlag);
        swal("처리되었습니다").then(function () {
          location.reload();
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //커뮤니티 댓글 작성
    fnSetReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      swal({
        text : "댓글을 작성하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          let vm = this;
          let param = {};
          param.brdUidKey = $("#paramUid").val();
          param.usrKey = $("#usrKey").val();
          if (_depth == 0) {
            param.replyDepth = _depth;
            param.replyContent = vm.insertReplyModel.replyContent;
            if (!vm.insertReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          } else if (_depth == 1) {
            param.replyDepth = _depth;
            param.replyContent = vm.insertReReplyModel.replyContent;
            param.parentsUidKey = replyUidKey;
            if (!vm.insertReReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          }

          Axios.post("/customer/homebase/insertReply", {homeBaseReplyVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                buttons: {
                  cancel: {text: "취소", value: false, visible: false,},
                  confirm: {text: "확인", value: true, visible: true,},
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });

    },
    //커뮤니티 댓글 수정
    fnUptReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      swal({
        text : "댓글을 수정하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          let vm = this;
          let param = {};
          param.usrKey = $("#usrKey").val();
          if (_depth == 0) {
            param.replyUidKey = replyUidKey;
            param.replyContent = vm.updateReplyModel.replyContent;
            if (!vm.updateReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          } else if (_depth == 1) {
            param.replyUidKey = replyUidKey;
            param.replyContent = vm.updateReReplyModel.replyContent;
            if (!vm.updateReReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          }

          Axios.post("/customer/homebase/updateReply", {homeBaseReplyVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {text: "취소", value: false, visible: false,},
                  confirm: {text: "확인", value: true, visible: true,},
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });


    },
    //커뮤니티 댓글 삭제
    fnDelReply: function (replyUidKey) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.replyUidKey = replyUidKey;

      swal({
        text : "댓글을 삭제하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          Axios.post("/customer/homebase/deleteReply", {homeBaseReplyVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });


    },
    fnSetReport1: function () {
      this.fnSetReport('report')
    },
    //게시글 추천/신고 하기
    fnOpenReport: function (kind) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        if (kind == 'report') {
          swal({
            text: "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
            closeOnClickOutside: false,
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
              cancel: {
                text: "취소",
                value: false,
                visible: true
              }
            }
          }).then(result => {
            if (result) {
              location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
            }
          });

        }
        return false;
      }

      if (kind == 'report') {
        if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신이 올린 글은 신고할 수 없습니다.");

          return false;
        } else {

          let _userKey = $("#usrKey").val();

          if(_userKey != null && _userKey != ""){
            let param = {
              uidKey : $("#paramUid").val()
              , userKey : _userKey
            };
            let reportFlag = false;
            if (vm.viewModel.reportList.length > 0) {
              vm.viewModel.reportList.forEach(function (report) {
                if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
                  reportFlag = true;
                }
              });
            }
            if(reportFlag) {
              swal("접수된 신고 이력이 있습니다.");
              return;
            }
            vm.viewModel.isReport = !vm.viewModel.isReport;
          }else{
            swal({
              text: "신고하기는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
              closeOnClickOutside: false,
              // // icon: vm.fnOnLoadSwalImageData('info'),
              buttons: {
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
                cancel: {
                  text: "취소",
                  value: false,
                  visible: true
                }
              }
            }).then(result => {
              if (result) {
                location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
              }
            });
          }

        }


      }
    },
    fnSetReport: function (kind) {
      let vm = this;
      let url = "/customer/homebase/insertRecommend";

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "좋아요는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (kind == 'report') {
        let reportFlag = false;
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
              reportFlag = true;
            }
          });
        }

        if (reportFlag) {
          swal("접수된 신고 이력이 있습니다.");
          return false;
        } else {
          if (vm.insertReport.reportValue == null || vm.insertReport.reportValue == "") {
            swal("신고사유를 선택해주세요.");
            return false;
          } else if(vm.insertReport.reportValue == 'RPTNVYTHNV00400' && vm.insertReport.reportEtcValue.trim().length == 0) {
            swal("기타사유를 입력해 주세요");
            return false;
          }
        }
      } else if (kind == 'like') {
        if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신의 동아리는 좋아요를 누를 수 없습니다.");
          vm.viewModel.isLike = false;
          return false;
        }
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100") { //좋아요
              url = "/customer/homebase/updateHomeBaseLike";
            }
          });
        }
      }

      // if(_reason == null || _reason.trim() == ""){
      //     alert("신고사유를 선택해 주세요");
      //     return false;
      // }

      // if(_reason == 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length == 0){
      //     alert("기타사유를 입력해 주세요");
      //     return false;
      // } else if(_reason == 'RPTNVYTHNV00400' && vm.mentoGroupModel.reportEtcValue.trim().length > 0){
      //     _reasonEtc = vm.mentoGroupModel.reportEtcValue.trim();
      // }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      if (kind == 'like') {
        param.rcmmCate = "RCMNVYTHNV00100"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.likeYn = 'Y';
      } else if (kind == 'report') {
        param.rcmmCate = "RCMNVYTHNV00200"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.reportValue = vm.insertReport.reportValue;
        if (vm.insertReport.reportValue == "RPTNVYTHNV00400") {
          param.reportEtcValue = vm.insertReport.reportEtcValue;
        }
      }

      Axios.post(url, {homeBaseVo: param}).then(function (response) {
        if (kind == 'like') {
          vm.viewModel.isLike = !vm.viewModel.isLike;
          if (vm.viewModel.reportList.length <= 2) { //신고+추천
            vm.viewModel.reportList.push(param);
          }

          if (vm.viewModel.isLike) {
            vm.viewModel.detail.likeCnt++;
          } else {
            vm.viewModel.detail.likeCnt--;
          }
        } else if (kind == 'report') {
          if (response.data.succCnt > 0) {
            swal("등록되었습니다.").then(result => {
              location.reload();
            });
            return false;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 상세보기 찜하기
    fnSetDetailZzim: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      let url = "/customer/homebase/insertHomeBaseZzim";

      if (vm.viewModel.zzimYn == 'Y' || vm.viewModel.zzimYn == 'N') {
        url = "/customer/homebase/updateHomeBaseZzim";
      }

      if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
        swal("자신의 동아리는 찜할 수 없습니다");
        vm.viewModel.isZzim = false;
        return false;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post(url, {homeBaseVo: param}).then(function (response) {
        vm.viewModel.isZzim = !vm.viewModel.isZzim;
        vm.viewModel.zzimYn = vm.viewModel.isZzim ? 'Y' : 'N';
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 - 동아리내역 - 동아리 찜하기
    fnSetZzim: function (hbObj) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      let brdUidKey = hbObj.brdUidKey;
      let zzimYn = hbObj.zzimYn;
      let url = "/customer/homebase/insertHomeBaseZzim";

      if (zzimYn == 'Y' || zzimYn == 'N') {
        url = "/customer/homebase/updateHomeBaseZzim";
      }

      if (hbObj.usrKey == $("#usrKey").val()) {
        swal("자신의 동아리는 찜할 수 없습니다.");
        vm.viewModel.isZzim = false;
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = brdUidKey;

      Axios.post(url, {homeBaseVo: param}).then(function (response) {
        if (brdUidKey != null && brdUidKey != "") {
          if ($("#" + brdUidKey).hasClass("on")) {
            $("#" + brdUidKey).removeClass("on");
          } else {
            // swal("찜 목록에 추가되었습니다.");
            $("#" + brdUidKey).addClass("on");
            hbObj.zzimYn = 'Y';
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //뱃지 몰아주기(자기뱃지 감소+상대뱃지 증가)
    fnOnClickDismissBadge: function (_value, _targetUsrKey, _targetUsrId) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      swal({
        text : "뱃지를 선물하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          let vm = this;
          if ($("#usrKey").val() == vm.viewModel.detail.usrKey) {
            swal("자신에게 뱃지를 선물할 수 없어요.");
            return false;
          }

          if(_value == '' || _value == '0') {
            swal("뱃지 갯수를 확인해주세요.");
            return false;
          }
          if (_value > vm.viewModel.badgeCount) {
            swal("보유하신 뱃지보다 많은 뱃지를 선물할 수 없습니다.\n뱃지 갯수를 확인해주세요.");
            return false;
          }

          vm.fnSetGiveBadge(_value * -1, null, null, _targetUsrId, 'MNUNVBTGNV10000'); //감소
          vm.fnSetGiveBadge(_value, _targetUsrKey, _targetUsrId, null, 'MNUNVBTGNV10001'); //증가

          let param = {};
          param.brdUidKey = $("#paramUid").val();
          param.badgeCnt = _value;

          //게시판에 반영
          Axios.post("/customer/homebase/updateBoardBadgeCnt", {homeBaseVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal("뱃지를 선물하였습니다.").then(result => {
                window.location.reload();
              });
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });

    },
    //뱃지 몰아주기
    fnSetGiveBadge: function (_value, _targetUsrKey, _targetUsrId, _className, _category) {
      let vm = this;
      let param = {paramDetail: {}};
      if (_targetUsrKey != null && _targetUsrKey != "") {
        param.paramDetail.uidKey = _targetUsrKey;
        param.paramDetail.insertid = _targetUsrId;
      } else {
        param.paramDetail.uidKey = $("#usrKey").val();
        param.paramDetail.insertid = $("#usrId").val();
      }
      if(_className != null && _className != '') {
        param.paramDetail.className = _className;
      } else {
        param.paramDetail.className = $("#usrId").val();
      }
      param.paramCate = _category;
      param.paramDetail.hit = _value;
      param.paramDetail.viewyn = 'Y';

      Axios.post("/customer/homebase/updateBadge", param).then(function (response) {

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 온라인축제 예약하기
    fnSetLiveFestival: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      let reserveStartHh = vm.insertLiveModel.reserveStartHh ? vm.insertLiveModel.reserveStartHh : "00";
      let reserveEndHh = vm.insertLiveModel.reserveEndHh ? vm.insertLiveModel.reserveEndHh : "00";
      let reserveStartMm = vm.insertLiveModel.reserveStartMm ? vm.insertLiveModel.reserveStartMm : "00";
      let reserveEndMm = vm.insertLiveModel.reserveEndMm ? vm.insertLiveModel.reserveEndMm : "00";

      if (vm.insertLiveModel.title == null || vm.insertLiveModel.title == "") {
        swal("제목을 입력해주세요");
        return false;
      }

      if (vm.insertLiveModel.progressValues.length < 1) {
        let offset = $("#progress").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('역량을 선택해 주세요.');
      }

      if (vm.insertLiveModel.lineValues.length < 1) {
        let offset = $("#line").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('계열을 선택해 주세요.');
      }

      if (vm.insertLiveModel.esg === '') {
        let offset = $("#esg").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('ESG 역량을 선택해 주세요.');
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdSubCtg = 'BRDNVYTHNV02600'; //온라인축제
      param.title = vm.insertLiveModel.title;
      param.content = vm.insertLiveModel.content;
      param.reserveSurveyYn = vm.insertLiveModel.reserveSurveyYn;
      param.reserveStartDate = vm.dateFormatter(vm.insertLiveModel.reserveDate, "-") + " " + reserveStartHh + ":" + reserveStartMm + ":00";
      param.reserveEndDate = vm.dateFormatter(vm.insertLiveModel.reserveDate, "-") + " " + reserveEndHh + ":" + reserveEndMm + ":00";
      param.progressList = vm.insertLiveModel.progressValues; // 역량
      param.subject = vm.insertLiveModel.lineValues;     // 계열
      param.esg = vm.insertLiveModel.esg;            // esg

      //설문조사 있을경우
      if (vm.insertLiveModel.reserveSurveyYn == 'Y') {
        if (vm.insertLiveModel.startDate > vm.insertLiveModel.endDate) {
          swal("시작일이 종료일보다 클 수 없습니다.");
          return false;
        } else if ((vm.insertLiveModel.startDate == null || vm.insertLiveModel.startDate == "")
          || (vm.insertLiveModel.endDate == null || vm.insertLiveModel.endDate == "")) {
          swal("시작일/종료일을 확인해주세요.");
          return false;
        }
        param.startDate = vm.dateFormatter(vm.insertLiveModel.startDate, "-"); //설문조사 시작일
        param.endDate = vm.dateFormatter(vm.insertLiveModel.endDate, "-"); //설문조사 종료일
      }

      let url = "/customer/homebase/insertLiveFestival";
      if ($("#paramUid").val() != null && $("#paramUid").val() != "") { //수정
        url = "/customer/homebase/updateLiveFestival";
        param.brdUidKey = $("#paramUid").val();
      }

      Axios.post(url, {homeBaseVo: param}).then(function (response) {
        if ($("#paramUid").val() != null && $("#paramUid").val() != "") { //수정
          if (vm.insertLiveModel.isUpdate) {
            vm.onUpdate($("#paramUid").val());
          } else {
            vm.onCreate($("#paramUid").val());
          }

        } else {
          if (response.data.homeBaseVo.succCnt > 0) {
            vm.onCreate(response.data.homeBaseVo.brdUidKey);
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 커뮤니티 예약 설문조사 등록
    changeSurvey: function (val) {
      let vm = this;
      vm.viewModel.surveyList = val;
    },
    //설문조사 항목 등록
    onCreate(_paramUidKey) {
      let vm = this;
      let _string = JSON.stringify(vm.viewModel.surveyList);
      let param = {};
      param.resultData = JSON.stringify({uidKey: _paramUidKey, list: _string});

      Axios.post("/api/survey/insert", param).then(function (response) {
        swal("등록되었습니다.").then(result => {
          window.history.back();
        });
        return false;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //설문조사 항목 수정
    onUpdate(_paramUidKey) {
      let vm = this;
      let _string = JSON.stringify(vm.viewModel.surveyList);
      let param = {};
      param.resultData = JSON.stringify({uidKey: _paramUidKey, list: _string});

      Axios.post("/api/survey/update", param).then(function (response) {
        swal("등록되었습니다.").then(result => {
          window.history.back();
        });
        return false;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //설문조사 항목 삭제
    onDelete(_paramUidKey) {
      let vm = this;
      let _string = JSON.stringify(vm.viewModel.surveyList);
      let param = {};
      param.resultData = JSON.stringify({uidKey: _paramUidKey, list: _string});

      Axios.post("/api/survey/delete", param).then(function (response) {
        swal("삭제되었습니다.").then(result => {
          vm.fnGetRsrvFestivalList();
        });
        return false;
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //온라인축제 게시글 삭제
    fnDelLiveFestival: function (uid) {
      let vm = this;
      let param = {};
      param.brdUidKey = uid;

      if (!confirm("삭제하시겠습니까?")) {
        return false;
      }

      Axios.post("/customer/homebase/deleteHomeBase", {homeBaseVo: param}).then(function (response) {
        vm.onDelete(uid);
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //마이내비 공지사항 등록
    fnSetNotice: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.brdSubCtg = "BRDNVYTHNV02500"; //공지사항
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.title = vm.insertNoticeModel.title;
      param.content = vm.insertNoticeModel.content;

      // if(!vm.insertNewsModel.content){
      //      alert("내용을 입력해주세요.");
      //      return false;
      // }

      Axios.post("/customer/homebase/insertNotice", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //마이내비 공지사항 수정
    fnUptNotice: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val(); //공지사항
      param.usrKey = $("#usrKey").val();
      param.fileKey = $("#fileKey").val();
      param.title = vm.insertNoticeModel.title;
      param.content = vm.insertNoticeModel.content;

      // if(!vm.insertNewsModel.content){
      //      alert("내용을 입력해주세요.");
      //      return false;
      // }

      Axios.post("/customer/homebase/updateNotice", {homeBaseVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          swal("등록되었습니다.").then(result => {
            window.history.back();
          });
          return false;
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {text: "취소", value: false, visible: false,},
              confirm: {text: "확인", value: true, visible: true,},
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //온라인축제 만족도 설문 참여
    fnSetLiveFestivalSurvey: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
                text : "확인",
                value : true,
                visible : true
              },
              cancel : {
                text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      let vm = this;
      let param = {};
      param.brdUidKey = vm.viewModel.currBrdUidKey //현재 선택한 온라인축제
      param.usrKey = $("#usrKey").val();

    },
    //다시보기 - 온라인축제 참여신청
    fnRegLiveFestival: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      let now = new Date();
      let srvyStDt = new Date(vm.viewModel.detail.startDate);
      let srvyEdDt = new Date(vm.viewModel.detail.endDate);
      srvyEdDt.setDate(srvyEdDt.getDate() + 1);
      srvyEdDt.setHours(0);

      if (srvyStDt < now && now < srvyEdDt) {
        Axios.post("/customer/homebase/insertRegLive", {homeBaseVo: param}).then(function (response) {

        }).catch(function (ex) {
          console.log(ex);
        });
      }
    },
    //동아리 가입신청취소
    fnCancelReg: function (brdUidKey) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let param = {};
      param.brdUidKey = brdUidKey != null ? brdUidKey : $("#paramUid").val();
      param.regUsrKey = $("#usrKey").val();

      Axios.post("/customer/homebase/updateRegCancel", {homeBaseVo: param}).then(function (response) {

        // console.log("response.data = ", response.data)
        // 탈퇴 과정에서 오류가 발생했을때 화면에 보여준다.
        if (response?.data?.statusCode === "500" && response?.data?.exType === "ServiceException") {
          swal(response?.data?.message).then(result => {
          });
          return false;
        }

        if (response.data.succCnt > 0) {
          swal("가입취소가 완료되었습니다.").then(result => {
            window.location.reload();
          });
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //동아리 탈퇴
    fnJoinOutHomeBase: function (brdUidKey) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let param = {};
      param.brdUidKey = brdUidKey;
      param.regUsrKey = $("#usrKey").val();

      swal({
        text: "탙퇴하시겠습니까?",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/customer/homebase/updateRegCancel", {homeBaseVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal("탈퇴가 완료되었습니다.").then(result => {
                window.location.reload();
              });
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      }).catch(function (ex) {
        swal({
          text: "오류가 발생하였습니다.",
          // icon: this.fnOnLoadSwalImageData("error"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: false},
            cancle: {text: "취소", value: false, visible: false}
          }
        });
      });
    },
    fnReqDelHomeBaseThis: function (delReqYn) {
      let brdUidKey = $('#paramUid').val();
      this.fnReqDelHomeBase(brdUidKey, delReqYn);
    },
    //커뮤니티 삭제요청
    fnReqDelHomeBase: function (uid, delReqYn) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = uid;
      param.delReqYn = delReqYn;

      //삭제요청
      if (delReqYn == "Y") {
        swal({
          text: "삭제요청 하시겠습니까?\n동아리원들의 동의가 필요합니다.",
          // icon: vm.fnOnLoadSwalImageData("info"),
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: true},
            cancle: {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            Axios.post("/customer/homebase/requestDelHomeBase", {homeBaseVo: param}).then(function (response) {
              swal("삭제요청 되었습니다.").then(result => {
                window.location.reload();
              });
            }).catch(function (ex) {
              console.log(ex);
            });
          }
        }).catch(function (ex) {
          swal({
            text: "오류가 발생하였습니다.",
            // icon: this.fnOnLoadSwalImageData("error"),
            closeOnClickOutside: false,
            buttons: {
              confirm: {text: "확인", value: true, visible: false},
              cancle: {text: "취소", value: false, visible: false}
            }
          });
        });
      } else if (delReqYn == "N") { //삭제요청 취소
        Axios.post("/customer/homebase/requestDelHomeBase", {homeBaseVo: param}).then(function (response) {
          swal("요청을 취소하였습니다.\n이 동아리는 나의 개설 커뮤니티에서 다시 볼 수 있습니다.").then(result => {
            window.location.reload();
          });
        }).catch(function (ex) {
          console.log(ex);
        });
      }

    },
    //커뮤니티 삭제요청 동의/거절
    fnAprvDelHomeBase: function (uid, aprv) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.brdUidKey = uid;
      param.delAprv = aprv;

      Axios.post("/customer/homebase/aprvDelHomeBase", {homeBaseVo: param}).then(function (response) {
        let msg = "";
        if (aprv == "approve") {
          msg = "동의하였습니다.";
        } else if (aprv == "reject") {
          msg = "거절하였습니다.";
        }

        swal(msg).then(result => {
          window.location.reload();
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    /*============================================================ 저장 end ========================================================================*/,
    //콘텐츠/커뮤니티 상세보기 이동
    fnGoDetail: function (obj) {
      let vm = this;
      if (obj.brdTabCtg == "HBTABCATENV000110") { //콘텐츠
        vm.fnGoContentsDetail(obj.brdUidKey);
      } else if (obj.brdTabCtg == "HBTABCATENV000120") { //커뮤니티
        if (obj.type == "HBCMNTYNV000160") { //커뮤니티-투표
          vm.fnGoCommunitySurvey(obj.brdUidKey);
        } else { //커뮤니티-나머지
          vm.fnGoCommunityDetail(obj.brdUidKey);
        }
      }

    },
    //동아리 내 탭 이동
    fnOnClickHomeBaseTab: function (paramUid, tabIdx, ltype) {
      if (paramUid == '') {
        paramUid = $('#paramUid').val();
        console.log(paramUid);
      }
      let searchSubject = $('#searchSubject').val();

      const addLtype = (ltype !== undefined && ltype !== null) ? "&ltype=" + ltype : ""

      if (searchSubject != null && searchSubject != '' && searchSubject != undefined) {
        location.href = "/customer/homebase/homeBaseDetail?paramUid=" + paramUid + "&searchSubject=" + searchSubject + "&tabIdx=" + tabIdx + addLtype;
      } else {
        location.href = "/customer/homebase/homeBaseDetail?paramUid=" + paramUid + "&tabIdx=" + tabIdx + addLtype;
      }

    },
    //주간 HOT 동아리, 60초 챌린지 상세 페이지 각자 목록으로 이동
    fnOnClickHomeBaseList: function () {
      let vm = this;
      let brdCtg = vm.viewModel.detail.brdSubCtg;
      let brdTabCtg = vm.viewModel.detail.brdTabCtg;

      if (brdCtg === 'BRDNVYTHNV02400') { // 60초 챌린지
        location.href = "/customer/homebase/challengeMain";
      }

      if (brdTabCtg === 'HBTABCATENV000110') { // 동아리 컨텐츠
        const homeUid = $('#homeUid').val();
        if (homeUid != null && homeUid !== '' && homeUid !== 'undefined') {
          // 특정 동아리의 컨텐츠 탭으로 이동
          location.href = "/customer/homebase/homeBaseDetail?paramUid=" + homeUid + "&tabIdx=2";
        } else {
          // 동아리 컨텐츠 목록으로 이동
          location.href = "/customer/homebase/weeklyHotContentsMain";
        }
      }

      // //주간 HOT 동아리
      // if (brdCtg == 'HBSUIDNV_00000000000000002861'){
      //     location.href="/customer/homebase/weeklyHotContentsMain";
      // }
      // //60초 챌린지
      // else if (brdCtg == 'BRDNVYTHNV02400'){
      //     location.href="/customer/homebase/challengeMain";
      // }
    },
    //동아리 상세보기 탭 이동
    fnHomeBaseTab: function (tabIdx) {
      let _tabIdx = !tabIdx ? 1 : tabIdx;
      let vm = this;

      if (_tabIdx != 1) {
        if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
          swal({
            text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
            closeOnClickOutside : false,
            buttons : {
              confirm : {
                text : "확인",
                value : true,
                visible : true
              },
              cancel : {
                text : "취소",
                value : false,
                visible : true
              }
            }
          }).then(result => {
            if(result){
              location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
            }
          });
          return false;
        }
      }

      if (_tabIdx == 1) { //동아리 소개
        vm.viewModel.isHbIntroTab = true;
        vm.viewModel.isHbContentsTab = false;
        vm.viewModel.isHbCommunityTab = false;
        vm.viewModel.isHbMemberTab = false;
      } else if (_tabIdx == 2) { //동아리 컨텐츠
        vm.viewModel.isHbIntroTab = false;
        vm.viewModel.isHbContentsTab = true;
        vm.viewModel.isHbCommunityTab = false;
        vm.viewModel.isHbMemberTab = false;
      } else if (_tabIdx == 3) { //동아리 커뮤니티
        vm.viewModel.isHbIntroTab = false;
        vm.viewModel.isHbContentsTab = false;
        vm.viewModel.isHbCommunityTab = true;
        vm.viewModel.isHbMemberTab = false;
      } else if (_tabIdx == 4) { //동아리 참여자
        vm.viewModel.isHbIntroTab = false;
        vm.viewModel.isHbContentsTab = false;
        vm.viewModel.isHbCommunityTab = false;
        vm.viewModel.isHbMemberTab = true;
      }
    },
    //동아리 컨텐츠 업로드 참여자 체크 해제
    fnUnChkMember: function (regUsrKey) {
      let vm = this;
      if (regUsrKey != "" && regUsrKey != null) {
        let idx = vm.insertHbCntntModel.member.indexOf(regUsrKey);
        vm.insertHbCntntModel.member.splice(idx);
      } else {
        vm.insertHbCntntModel.member = [];
        vm.viewModel.isCntntMember = false;
        vm.selectHbModelMemberType = "";
      }
    },
    //동아리 커뮤니티 항목 추가
    fnAddSurvey: function () {
      let vm = this;
      vm.insertCommunityModel.surveyList.push({surveyContent: ""});
    },
    //동아리 커뮤니티 항목 순서 변경
    fnSwitchSurvey: function (idx, move) {
      let vm = this;
      let leng = vm.insertCommunityModel.surveyList.length;

      if ((move < 0 && idx != 0) || (move > 0 && idx != leng - 1)) {
        let tmp = vm.insertCommunityModel.surveyList.splice(idx, 1);
        vm.insertCommunityModel.surveyList.splice(idx + move, 0, tmp[0]);
      }

      if (move == 0) {
        vm.insertCommunityModel.surveyList.splice(idx, 1);
      }
    },
    //댓글작성 초기화
    fnClearReply: function () {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //댓글작성 레이아웃 출력
    fnShowReplyWrite: function () {
      let vm = this;
      vm.viewModel.isReply = true;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //대댓글 작성 레이아웃 출력
    fnShowReReplyWrite: function (key) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = true;
      vm.viewModel.isReReplyUpt = false;
      vm.viewModel.currReplyUidKey = key;
    },
    //댓글 수정 값 세팅
    fnReplySetValue: function (vo) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
      vm.fpt = ''
      if (vo.replyDepth == 0) {
        vm.viewModel.isReplyUpt = true;
        vm.updateReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReplyModel.replyContent = vo.replyContent;
      } else if (vo.replyDepth == 1) {
        vm.viewModel.isReReplyUpt = true;
        vm.updateReReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReReplyModel.replyContent = vo.replyContent;
      }
    },
    //날짜 포맷 변경
    dateFormatter: function (paramDate, delimiter) {
      const date = new Date(paramDate);
      const deli = delimiter ? delimiter : "";
      const year = date.getFullYear();
      const month = (date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1);
      const day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
      return [year, month, day].join(deli);
    },
    //주간 날짜 생성
    fnSetWeekDate: function () {
      let vm = this;
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      vm.viewModel.weekStartDate = vm.dateFormatter(startDate, ".");
      vm.viewModel.weekEndDate = vm.dateFormatter(endDate, ".");
    },
    //신고하기 레이아웃 출력
    fnShowReportWrite: function () {
      let vm = this;
      let _userKey = $("#usrKey").val();

      if(_userKey != null && _userKey != ""){
        let param = {
          uidKey : $("#paramUid").val()
          , userKey : _userKey
        };

        Axios.post("/api/expinfo/isDeclare", param).then(function(response) {
          let result = response.data.result;
          if(result == 1){
            swal("접수된 신고 이력이 있습니다.");
            return;
          }else{
            vm.viewModel.isReport = !vm.viewModel.isReport;
          }

        }).catch(function(ex) {
          console.log(ex);
        });
      }else{
        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          // // icon: vm.fnOnLoadSwalImageData('info'),
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      }


    },
    //페이징 처리
    fnSetPager: function (totalCount, etc, paramPager) {
      let vm = this;
      paramPager.etc = etc;
      paramPager.totalSize = totalCount;
      paramPager.pageNum = (paramPager.pageNo * paramPager.rowSize) - paramPager.rowSize;
      Pager.props = Pager.methods.createPager(paramPager, vm, "list");
    },
    //동아리 권한 변경
    fnSetHomeBaseAuth: function (id, event, item) {
      let vm = this;
      let optionValue = event.target.value;
      let optionText = event.target.options[event.target.options.selectedIndex].text;
      $("." + id).text(optionText);
      //동아리장 ->  동아리원
      //선택한사람 -> 선택한등급

      if (vm.viewModel.updateAuthList != null) {
        vm.viewModel.updateAuthList.forEach(function (auth) {
          if (item.usrKey == auth.usrKey) {
            auth.hbAuth = optionValue;
          }
        });
      }
    },
    //시간:분 선택 세팅
    fnSetHourMinute: function () {
      let vm = this;
      for (let i = 0; i < 24; i++) {
        let _val = i;
        if (_val < 10) {
          _val = '0' + _val;
        }

        let _option = {key: _val, value: _val};
        vm.viewModel.hourList.push(_option);
      }

      for (let i = 0; i < 60; i += 10) {
        let _val = i;
        if (_val == 0) {
          _val = '0' + _val;
        }

        let _option = {key: _val, value: _val};
        vm.viewModel.minuteList.push(_option);
      }
    },
    //개월 버튼
    onClickDateBtn: function (_num) {
      let vm = this;
      let startDate = new Date();
      let endDate = new Date();
      vm.searchModel.endDate = endDate;
      vm.searchModel.startDate = new Date(startDate.setDate(startDate.getDate() - _num));
    },
    //html 태그 제거
    fnRemoveHTML: function (text) {
      text = text.replace(/<br\/>/ig, "\n");
      text = text.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "");
      return text;
    },
    //비디오 업로드 편집 초기값 세팅
    fnChgVideoOption: function () {
      if ($('#parentsUid').val() == "BRDNVYTHNV02400") { //60초 챌린지
        this.detailOption = {durTime: "00:00:00", setTime: "60", isTime: false}; //영상길이 0초부터 60초 만큼 편집
      } else {
        this.detailOption = {}; //영상길이 편집 없음
      }
    },
    //에디터 사용
    onEditorChange: function (event) {
      let vm = this;
      // this.viewModel.detail.cmm_cntnt = event.html;
      let pageName = $("#pageName").val();

      if (pageName == "galleryInsertMain") {
        vm.insertGalleryModel.content = event.html;
      } else if (pageName == "contentsInsertMain") {
        vm.insertHbCntntModel.content = event.html;
      } else if (pageName == "communityInsertMain" || pageName == "promotionInsertMain") {
        vm.insertCommunityModel.content = event.html;
      } else if (pageName == "homeBaseInsertMain" || pageName == "homeBaseUpdateMain") {
        vm.insertHbModel.content = event.html;
      } else if (pageName == "myNoticeInsertMain") {
        vm.insertNoticeModel.content = event.html;
      }
      this.$emit("getEditorInfo", event);
    },
    //설문조사 답변 생성(객관식)
    fnMkSurveyAnswer: function (obj, subIndex) {
      let answerArr = [];
      obj.surveyItem.forEach(function (item, index) {
        let answer = subIndex == index ? 'Y' : 'N';
        answerArr.push(answer);
      });

      obj.surveyAnswer = answerArr.join('|');
    },
    //설문조사 답변 생성(주관식)
    fnMkSurveyInputAnswer: function (obj, event) {
      let data = event.target.value;
      obj.surveyAnswer = data;
    },
    //숫자만 입력
    fnMaxCntBindNumber(event) {
      let value = event.target.value;

      let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
      if (reg.exec(value) !== null) {
        this.insertHbModel.maxCnt = value.replace(/[^0-9]/g, '');
      }

      if (isNaN(parseInt(value))) {
        this.insertHbModel.maxCnt = '';
      } else {
        this.insertHbModel.maxCnt = parseInt(value);
      }
    },
    //숫자만 입력
    fnBadgeCntBindNumber(event) {
      let value = event.target.value;

      let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
      if (reg.exec(value) !== null) {
        this.viewModel.insertBadgeCount = value.replace(/[^0-9]/g, '');
      }

      if (isNaN(parseInt(value))) {
        this.viewModel.insertBadgeCount = '';
      } else {
        if(parseInt(value) < 0) {
          this.viewModel.insertBadgeCount = 0;
        }
         else {
          this.viewModel.insertBadgeCount = parseInt(value);
        }

      }
    },
    fnBadgeCntBindNumberBlur() {
      let value = $('#insertBadgeCount').val();

      let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
      if (reg.exec(value) !== null) {
        $('#insertBadgeCount').val(value.replace(/[^0-9]/g, ''));
      }

      if (isNaN(parseInt(value))) {
        $('#insertBadgeCount').val('');
      } else {
        if(parseInt(value) < 0) {
          $('#insertBadgeCount').val('0');
        }
        else {
          $('#insertBadgeCount').val(parseInt(value));
        }

      }
    },
    fnSurveyResultPopup: function (uidKey) {
      let url = '/youthnavi/mypage/center/homebase/surveyResult?paramUid=' + uidKey;
      window.open(url, "만족도조사 결과", "width=800, height=700, toolbar=no, menubar=no, scrollbars=no, resizable=yes");
    }
    //벨리데이션 포커스 함수
    /*
            param   : true/false 변수 object
            return  : false 개수 return
            선행작업 : 1.true/false 변수 object 선언
                      2.jsp 페이지 각 input에 ref="is변수명"

            ex) - controller.js
                    valiObj:{
                                isSubject:false,
                                isTarget:false
                            }
                - jsp 페이지
                    <input type="text" class="form_style" v-model="insertHbModel.title" ref="isSubject">

                - 사용
                    let vm = this;
                    if(vm.fnValidateChk(vm.valiObj) > 0){
                        return false;
                    }
        */,
    fnValidateChk: function (validateObj) {
      let vm = this;
      let chkLegnth = 0;
      for (let item in validateObj) {
        if (validateObj[item] == false) {
          chkLegnth++;
          vm.$refs[item].focus();
          break;
        }
      }
      return chkLegnth;
    }
    /*============================================================ 공유 start ========================================================================*/,
    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    },
    fnOnLoadKakaoContent: function (value) {
      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      if (_atag == null) {
        return '';
      }
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      if (_nbsptag == null) {
        return '';
      }
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");
      if (_httptag == null) {
        return '';
      }
      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;
    },

    fnOnClickKakaoShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'contentsDetail') {
          _uri = urlAddress + '/customer/homebase/contentsDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'communityDetail') {
          _uri = urlAddress + '/customer/homebase/communityDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'promotionDetail') {
          _uri = urlAddress + '/customer/homebase/promotionDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'galleryDetail') {
          _uri = urlAddress + '/customer/homebase/galleryDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'liveFestivalVodDetail') {
          _uri = urlAddress + '/customer/homebase/liveFestivalVodDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'noticeDetail') {
          _uri = urlAddress + '/customer/homebase/noticeDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'homeBaseDetail') {
          _uri = urlAddress + '/customer/homebase/homeBaseDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        if (vm.viewModel.fileImgList.length > 0) {
          // _imgPath = "https://new.youthnavi.net/" + vm.viewModel.fileImgList[0].fileUrl;
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          // _imgPath = 'https://new.youthnavi.net//design/common/images/sub/img_noimg.png';
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath,
          '',
          '',
          '',
          '',
          ''
        );
      });
    },
    fnOnClickNaverShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'contentsDetail') {
          _uri = urlAddress + '/customer/homebase/contentsDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'communityDetail') {
          _uri = urlAddress + '/customer/homebase/communityDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'promotionDetail') {
          _uri = urlAddress + '/customer/homebase/promotionDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'galleryDetail') {
          _uri = urlAddress + '/customer/homebase/galleryDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'liveFestivalVodDetail') {
          _uri = urlAddress + '/customer/homebase/liveFestivalVodDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'noticeDetail') {
          _uri = urlAddress + '/customer/homebase/noticeDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'homeBaseDetail') {
          _uri = urlAddress + '/customer/homebase/homeBaseDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath
        );
      });
    },
    fnOnClickFacebookShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'contentsDetail') {
          _uri = urlAddress + '/customer/homebase/contentsDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'communityDetail') {
          _uri = urlAddress + '/customer/homebase/communityDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'promotionDetail') {
          _uri = urlAddress + '/customer/homebase/promotionDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'galleryDetail') {
          _uri = urlAddress + '/customer/homebase/galleryDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'liveFestivalVodDetail') {
          _uri = urlAddress + '/customer/homebase/liveFestivalVodDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'noticeDetail') {
          _uri = urlAddress + '/customer/homebase/noticeDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'homeBaseDetail') {
          _uri = urlAddress + '/customer/homebase/homeBaseDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);
        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    },
    fnOnClickLinkShare: function () {
      let vm = this;
      let _pageName = $("#pageName").val();
      let _uidKey = $("#paramUid").val();
      let _uri = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if (_pageName == 'contentsDetail') {
          _uri = urlAddress + '/customer/homebase/contentsDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'communityDetail') {
          _uri = urlAddress + '/customer/homebase/communityDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'promotionDetail') {
          _uri = urlAddress + '/customer/homebase/promotionDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'galleryDetail') {
          _uri = urlAddress + '/customer/homebase/galleryDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'liveFestivalVodDetail') {
          _uri = urlAddress + '/customer/homebase/liveFestivalVodDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'noticeDetail') {
          _uri = urlAddress + '/customer/homebase/noticeDetail?paramUid=' + _uidKey + "&shared=Y";
        } else if (_pageName == 'homeBaseDetail') {
          _uri = urlAddress + '/customer/homebase/homeBaseDetail?paramUid=' + _uidKey + "&shared=Y";
        }

        vm.fnShareLog(_uidKey);

        let popup_url = '/customer/activity/share/link';
        popup_url += '?url=' + encodeURIComponent(_uri);
        window.open(popup_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });
    },
    fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    }
    /*============================================================ 공유 end ========================================================================*/,
    // 계열위로 문구 출력
    fnOutAffText(value) {
      let vm = this;
      if (value == null || value == "" || value == undefined) {
        return "";
      } else {

        let aff = vm.viewModel.affToolTpList.find(item => item.code == value);
        if (aff != null) {
          return aff.text;
        } else {
          if(value == "HBGALLSBJCTNV000100") {
            return "자유갤러리";
          } else {
            return "";
          }
        }

      }
    },
    fnOutCbpText(value) { // 역량 안내문구
      let vm = this;
      if (value == null || value === "" || value === undefined) {
        return "";
      } else {
        const cbp = vm.viewModel.cbpToolTpList.find(item => item.uidKey === value);
        if (cbp != null) {
          return cbp.content;
        } else {
          return "";
        }

      }
    },
    fnOutEsgText(value) { // esg 안내문구
      let vm = this;
      if (value == null || value === "" || value === undefined) {
        return "";
      } else {
        let esg = vm.viewModel.esgToolTpLisst.find(item => item.code === value);
        if (esg != null) {
          return esg.text;
        } else {
          return "";
        }

      }
    },
    fnOnCbpList: function (lvl) { // 역량 툴팁 조회
      let vm = this;

      let param = {
        price: lvl
      };

      Axios.post("/api/expinfo/selectCbpList", param).then(function (response) {
        vm.viewModel.cbpToolTpList = response.data.cbpList;
      }).catch(function (ex) {
        console.log(ex);
      });
    }

    /* ---------------------------------------------------------------------------------------------------------------*/,
    fnSetLiveFestivalVod: function () {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;
      if (vm.insertLiveModel.title == null || vm.insertLiveModel.title == "") {
        swal("제목을 입력해주세요");
        return false;
      }

      // TODO CHECK :: 영상 체크
      // if (vm.$refs.dropvideo.cnt == 0) {
      //   alert("영상을 업로드 해주세요.")
      //   return false;
      // }

      if (vm.videoRes.resValue != null && vm.videoRes.resValue !== "succ") {
        alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
        return false;
      }

      if (vm.insertLiveModel.progressValues.length < 1) {
        let offset = $("#progress").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('역량을 선택해 주세요.');
      }

      if (vm.insertLiveModel.lineValues.length < 1) {
        let offset = $("#line").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('계열을 선택해 주세요.');
      }

      if (vm.insertLiveModel.esg === '') {
        let offset = $("#esg").offset();
        $("html, body").animate({scrollTop: offset.top - 100}, 400);
        return swal('ESG 역량을 선택해 주세요.');
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.fileKey = $("#fileKey").val();
      param.brdSubCtg = 'BRDNVYTHNV02600'; // 온라인축제
      param.brdTabCtg = 'BRDNVYTHNV02610'; // vod
      param.title = vm.insertLiveModel.title;
      param.content = vm.insertLiveModel.content;
      param.progressList = vm.insertLiveModel.progressValues; // 역량
      param.subject = vm.insertLiveModel.lineValues;     // 계열
      param.esg = vm.insertLiveModel.esg;            // esg

      let url = "/customer/homebase/insertLiveFestivalVod";
      let msg = "등록되었습니다.";
      if ($("#paramUid").val() != null && $("#paramUid").val() != "") { //수정
        url = "/customer/homebase/updateLiveFestivalVod";
        msg = "수정되었습니다."
        param.brdUidKey = $("#paramUid").val();
      }

      Axios.post(url, {homeBaseVo: param}).then(function (response) {
        swal(msg).then(result => {
          window.history.back();
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetNaviMentoPagingList(pageNo, searchOrder) { // 내비쌤 페이징 목록 조회
      let vm = this;

      vm.naviLi = searchOrder;
      vm.viewModel.onePager.pageNo = pageNo ? pageNo : 1;
      vm.viewModel.onePager.rowSize = 9;
      const subjectStr = $("#tab").val();

      const param = {
        lineList: subjectStr === '' ? [] : [subjectStr],
        pageNo: vm.viewModel.onePager.pageNo,
        pageSize: vm.viewModel.onePager.rowSize,
        searchOrder: searchOrder
      }

      Axios.post("/api/expinfo/naviMentoPagingList", param).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.naviMentoList = response.data.naviMenoMapList;
        vm.fnSetPager(vm.viewModel.totalCount, "selectNaviMentoList", vm.viewModel.onePager);
      }).catch(function (ex) {
        console.log(ex);
      });

      // const response = await Axios.post("/api/expinfo/naviMentoPagingList", param);
      // if (response == null) return;
      //
      // vm.viewModel.totalCount    = response.data.totalCount;
      // vm.viewModel.naviMentoList = response.data.naviMenoMapList;
      // vm.fnSetPager(vm.viewModel.totalCount, "selectNaviMentoList", vm.viewModel.onePager);
    },
    fnGetNaviMentoList(subjectStr, searchOrder) { // 내비쌤 목록 조회
      let vm = this;
      vm.naviLi = searchOrder;
      const param = {
        lineList: subjectStr === '' ? [] : [subjectStr],
        searchOrder: searchOrder
      }
      param.searchOrder = vm.naviLi;
      Axios.post("/api/expinfo/naviMentoList", param).then(function (response) {
        vm.viewModel.naviMentoList = response.data.naviMenoList;
        console.log("내비쌤", response.data);
      })
    },
    fnGoNaviMentoDetail(uid) { // 내비쌤 상세로 이동
      location.href = "/customer/homebase/naviMentoDetail?uidKey=" + uid;
      this.fnSetGalleyMainSessionStorage(); // 히스토리 백 저장
    },
    fnGetNaviMentoDetail() { // 내비쌤 상세 조회
      let vm = this;
      const uidKey = $("#uidKey").val();

      Axios.post("/api/expinfo/naviMentoDetail", {uidKey}).then(function (response) {
        vm.viewModel.naviMentoModel = response.data.naviMenoInfo;
        $("#paramUid").val("NAVI_MENTO_" + response.data.naviMenoInfo.cmm_usr_key); // 댓글용 key 셋팅
        $("#naviUsrKey").val(response.data.naviMenoInfo.cmm_usr_key); // 내비샘 usrKey 셋팅
        vm.fnGetReplyList(); // 댓글 조회
        vm.fnGetNaviMentoGalleryList(1); // 내비샘이 작성한 홈베갤러리 목록 조회
        vm.fnGetNaviMentoMeetList(); // 내비쌤이 개설한 화상회의 목록 조회
      })
    },
    async fnGetNaviMentoGalleryList(pageNumber = 1) { // 내비쌤이 작성한 홈베갤러리 목록 조회
      let vm = this;

      vm.viewModel.onePagerFiveRow.pageNo = pageNumber;

      const param = {
        uidKey: $("#naviUsrKey").val(),
        pageNo: vm.viewModel.onePagerFiveRow.pageNo,
        pageSize: vm.viewModel.onePagerFiveRow.rowSize,
      }

      const response = await Axios.post("/api/expinfo/naviMentoGalleryList", param)

      vm.viewModel.naviMentoGalleryList = response.data.logList;
      vm.fnSetPager(response.data.totalCount, "naviMentoGallery", vm.viewModel.onePagerFiveRow);
    },
    async fnGetNaviMentoMeetList() { // 내비쌤이 개설한 화상회의 목록 조회
      let vm = this;
      const param = {uidKey: $("#naviUsrKey").val()}
      const response = await Axios.post("/api/expinfo/fnGetNaviMentoMeetList", param)
      vm.viewModel.naviMentoMeetList = response.data.naviMenoMapList;
    },
    joinMeet(status, roomCode) {
      if (status !== '진행중') {
        return swal("진행 예정인 회의입니다.")
      }
      let _uri = "/meeting/room/" + roomCode;
      let _option = "top=500,left=500,width=1200,height=1200";
      let _name = "youthnavi_mpop_meet";

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        location.href = _uri
        // } else if (app_os === "AOS") {
        //   location.href = _uri
      } else {
        if (mobile())
          window.open(_uri, _name, _option);
        else
          window.open(_uri, _name); // 2023-08-03 :: 구루미 기능 중 화면녹화 기능을 사용하기 위해 toolbar가 나오는 창으로 open.
      }
    },
    fnOutGunLabel: function (val) { // 내비쌤 구분명 출력
      if (val == '1') return '대학생'
      if (val == '2') return '교수'
      if (val == '3') return '전문가'
    },
    fnCallImgAltSave: function () { // 이미지 alt 저장
      //this.$refs.dropimg.fnParentSaveCB()
    },
    fnChkShowReplyWrite() { // 로그인여부 확인 후, 댓글 입력창 열기
      if ($("#usrKey").val() == null || $("#usrKey").val() === "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      } else {
        this.fnShowReplyWrite();
      }
    },
    fnOnSetCode: function (_code) { // 코드 조회
      let vm = this;
      Axios.post("/api/expinfo/code", {searchCode: _code}).then(function (response) {
        if (_code === 'AFLNVADMNV000000') { // 계열
          vm.viewModel.lineList = response.data.expinfoCodeList;
        } else if (_code === 'ESGNVMNGNV00000') { // esg
          vm.viewModel.esgList = response.data.expinfoCodeList;
        } else if (_code === 'CPCNVADMNV000000') { // 역량
          vm.viewModel.progressList = response.data.expinfoCodeList;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGotoDetail: function (uidKey) {
      location.href = '/customer/homebase/communityDetail?paramUid=' + uidKey;
    },
    fnGotoPromoDetail: function (uidKey) {
      // 홍보게시판 상세로 넘어가기 직전 상태 저장
      try {
        if (typeof this.savePromoState === 'function') {
          this.savePromoState();
        }
      } catch (e) {
        console.error('[Promo] failed to save state before detail:', e);
      }
      sessionStorage.setItem(PROMO_BACK_INTENT_KEY, 'true');
      location.href = '/customer/homebase/promotionDetail?paramUid=' + uidKey;
    },
    saveGalleryState() {
      const state = {
        galleryList1: this.viewModel.galleryList1,
        totalCount: this.viewModel.totalCount,
        pager: {
          pageNo: this.viewModel.onePager.pageNo,
          rowSize: this.viewModel.onePager.rowSize
        },
        searchCode: this.searchModel.searchCode,
        searchOrder: this.searchModel.searchOrder,
        searchKword: this.searchModel.searchKword,
        selectedSubject: this.selectedSubject,
        selectedSubjectNm: this.selectedSubjectNm,
        fpt: this.fpt,
        rm1: this.rm1,
        scrollY: window.scrollY,
        timestamp: Date.now()
      };
      this.saveState(GALLERY_STATE_KEY, state);
    },
    restoreGalleryState() {
      try {
        const state = this.loadState(GALLERY_STATE_KEY);
        if (!state) {
          this.initPageCommon();
          return;
        }

        if (Date.now() - state.timestamp > STATE_TTL) {
          sessionStorage.removeItem(GALLERY_STATE_KEY);
          sessionStorage.removeItem(GALLERY_BACK_INTENT_KEY);
          this.initPageCommon();
          return;
        }

        // 상태 복원
        this.viewModel.galleryList1 = state.galleryList1 || [];
        this.viewModel.totalCount = state.totalCount || 0;
        this.viewModel.onePager.pageNo = state.pager.pageNo || 1;
        this.viewModel.onePager.rowSize = state.pager.rowSize || 10;
        this.searchModel.searchCode = state.searchCode || '';
        this.searchModel.searchOrder = state.searchOrder || '';
        this.searchModel.searchKword = state.searchKword || '';
        this.selectedSubject = state.selectedSubject || '';
        this.selectedSubjectNm = state.selectedSubjectNm || '';
        this.fpt = state.fpt || '';
        this.rm1 = state.rm1 || 1;

        // 기본 초기화도 실행
        this.qsMap = CommonTools.queryStringToMap();
        $(".mainName").before('<span class="page_tit_sm">청소년 </span>');

        const savedScrollY = state.scrollY || 0;
        this.$nextTick(function () {
          pageLoad(this);
        });
        this.restoreScroll(savedScrollY);
        var url = window.location;
        let params = new URLSearchParams(url.search);
        if (params.has('idx')) this.idx = params.get('idx')
        this.ensureKakaoInitialized();

        // 복원 완료 플래그 설정 (pageLoad에서 fnGetGalleryList2 호출 스킵용)
        this.isGalleryRestored = true;

        // 백 인텐트만 제거 (상태는 유지)
        sessionStorage.removeItem(GALLERY_BACK_INTENT_KEY);

        console.log('Gallery state restored from session storage');
      } catch (e) {
        console.error('Failed to restore gallery state:', e);
        sessionStorage.removeItem(GALLERY_STATE_KEY);
        sessionStorage.removeItem(GALLERY_BACK_INTENT_KEY);
        // 오류 시 정상 초기화
        this.initPageCommon();
      }
    },
    savePromoState() {
      const state = {
        communityList: this.viewModel.communityList,
        totalCountPromotion: this.viewModel.totalCountPromotion,
        pager: {
          pageNo: this.viewModel.twoPager.pageNo,
          rowSize: this.viewModel.twoPager.rowSize
        },
        searchKword: this.searchModel.searchKword,
        showMore: this.viewModel.showMore,
        scrollY: window.scrollY,
        timestamp: Date.now()
      };
      this.saveState(PROMO_STATE_KEY, state);
    },
    restorePromoState() {
      try {
        const state = this.loadState(PROMO_STATE_KEY);
        if (!state) {
          this.initPageCommon();
          return;
        }

        if (Date.now() - state.timestamp > STATE_TTL) {
          sessionStorage.removeItem(PROMO_STATE_KEY);
          sessionStorage.removeItem(PROMO_BACK_INTENT_KEY);
          this.initPageCommon();
          return;
        }

        // 상태 복원
        this.viewModel.communityList = state.communityList || [];
        this.viewModel.totalCountPromotion = state.totalCountPromotion || 0;
        this.viewModel.twoPager.pageNo = state.pager.pageNo || 1;
        this.viewModel.twoPager.rowSize = state.pager.rowSize || 10;
        this.searchModel.searchKword = state.searchKword || '';
        this.viewModel.showMore = state.showMore !== undefined ? state.showMore : true;

        // 기본 초기화도 실행
        this.qsMap = CommonTools.queryStringToMap();
        $(".mainName").before('<span class="page_tit_sm">청소년 </span>');

        const savedScrollY = state.scrollY || 0;
        this.$nextTick(function () {
          pageLoad(this);
        });
        this.restoreScroll(savedScrollY);
        var url = window.location;
        let params = new URLSearchParams(url.search);
        if (params.has('idx')) this.idx = params.get('idx')
        this.ensureKakaoInitialized();

        // 복원 완료 플래그 설정
        this.isPromoRestored = true;

        // 백 인텐트만 제거 (상태는 유지)
        sessionStorage.removeItem(PROMO_BACK_INTENT_KEY);

        console.log('Promo board state restored from session storage');
      } catch (e) {
        console.error('Failed to restore promo state:', e);
        sessionStorage.removeItem(PROMO_STATE_KEY);
        sessionStorage.removeItem(PROMO_BACK_INTENT_KEY);
        this.initPageCommon();
      }
    }
    ,
    // 주간 HOT 컨텐츠 상태 저장
    saveHotState() {
      const state = {
        contentsList: this.viewModel.contentsList,
        contentsImgList: this.viewModel.contentsImgList,
        totalCount: this.viewModel.totalCount,
        contentPager: {
          pageNo: this.viewModel.contentPager.pageNo,
          rowSize: this.viewModel.contentPager.rowSize,
          isHitSort: this.viewModel.contentPager.isHitSort
        },
        searchKword: this.searchModel.searchKword,
        showMore: this.viewModel.showMore,
        scrollY: window.scrollY,
        timestamp: Date.now()
      };
      this.saveState(HOT_STATE_KEY, state);
    }
    ,
    // 주간 HOT 컨텐츠 상태 복원
    restoreHotState() {
      try {
        const state = this.loadState(HOT_STATE_KEY);
        if (!state) {
          // 복원할 상태가 없으면 정상 초기화
          this.initPageCommon();
          return;
        }

        if (Date.now() - state.timestamp > STATE_TTL) {
          sessionStorage.removeItem(HOT_STATE_KEY);
          sessionStorage.removeItem(HOT_BACK_INTENT_KEY);
          // TTL 만료 시 정상 초기화
          this.initPageCommon();
          return;
        }

        // 상태 복원
        this.viewModel.contentsList = state.contentsList || [];
        this.viewModel.contentsImgList = state.contentsImgList || [];
        this.viewModel.totalCount = state.totalCount || 0;
        this.viewModel.contentPager.pageNo = state.contentPager && state.contentPager.pageNo ? state.contentPager.pageNo : 1;
        this.viewModel.contentPager.rowSize = state.contentPager && state.contentPager.rowSize ? state.contentPager.rowSize : this.viewModel.contentPager.rowSize;
        this.viewModel.contentPager.isHitSort = state.contentPager && state.contentPager.isHitSort ? state.contentPager.isHitSort : 'new';
        this.searchModel.searchKword = state.searchKword || '';
        this.viewModel.showMore = state.showMore !== undefined ? state.showMore : true;

        // 기본 초기화도 실행 (초기 fetch는 isHotRestored로 차단)
        this.qsMap = CommonTools.queryStringToMap();
        $(".mainName").before('<span class="page_tit_sm">청소년 </span>');

        const savedScrollY = state.scrollY || 0;
        // pageLoad 호출 전, 복원 플래그 설정하여 초기 조회 차단
        this.isHotRestored = true;
        this.$nextTick(function () {
          pageLoad(this);
        });
        this.restoreScroll(savedScrollY);
        var url = window.location;
        let params = new URLSearchParams(url.search);
        if (params.has('idx')) this.idx = params.get('idx')
        this.ensureKakaoInitialized();

        // 백 인텐트만 제거 (상태는 유지)
        sessionStorage.removeItem(HOT_BACK_INTENT_KEY);

        console.log('Weekly hot state restored from session storage');
      } catch (e) {
        console.error('Failed to restore weekly hot state:', e);
        sessionStorage.removeItem(HOT_STATE_KEY);
        sessionStorage.removeItem(HOT_BACK_INTENT_KEY);
      }
    }
  }
});

